import { useMemo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useApi } from '../../hooks/useApi';
import { useCompany } from '../../hooks/useCompany';
import { ACCESS_ROLES, getAccessRoleLabel } from '../../utils/access';
import { normalizeId } from '../../utils/formatters';
import { getCabinetRole, getWorkspaceRole } from '../../utils/workspaces';
import { handleMarketplaceSubmit as handleMarketplaceSubmitBase } from '../../services/marketplaces';
import { openEditAccount as openEditAccountBase, closeEditAccount as closeEditAccountBase, handleEditSubmit as handleEditSubmitBase } from '../../services/marketplace-edit';
import ProjectsList from './ProjectsList';
import DeletedCabinets from './DeletedCabinets';
import EditAccountModal from './EditAccountModal';
import TransferCabinetModal from './TransferCabinetModal';
import { formatUserFullName } from '../../utils/users';
import SupportPanel from './SupportPanel';
import AccountSection from '../account/AccountSection';
import AccountDataPanel from '../account/AccountDataPanel';
import PricingCatalogPanel from './PricingCatalogPanel';
import DadataSuggest from './DadataSuggest';
import { loadProfileSummary } from '../../services/company';
import { handleProfileSave as handleProfileSaveBase, handleAvatarUpload as handleAvatarUploadBase, handleCertificatesUpload as handleCertificatesUploadBase, handleTelegramLink as handleTelegramLinkBase, loadProfileStats as loadProfileStatsBase } from '../../services/profile';
import { IconCopy } from '../../components/icons';
import logger from "../../utils/logger";
import { copyText as copyToClipboard } from '../../utils/clipboard';
import { fmtDate } from '../../utils/ruDates';
const TX_PAGE = 50;
const t = {
  settings: 'Настройки',
  settings_desc: 'Управление кабинетами, проектами и правами доступа.',
  my_id: 'Мой ID:',
  copied: 'Скопировано в буфер обмена.',
  copy_fail: 'Не удалось скопировать.',
  copy: 'Скопировать',
  tab_access: 'Кабинеты, проекты, сотрудники',
  tab_billing: 'Баланс, тарифы и оплата',
  tab_referral: 'Реферальная программа',
  tab_account: '\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442',
  tab_ai: 'AI \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438',
  tab_support: 'Помощь и техподдержка',
  tab_api: 'Внутренний API',
  company_settings: 'Плательщик',
  company_name: 'Название плательщика',
  account_name: 'Название кабинета',
  inn: 'ИНН',
  legal_address: 'Юридический адрес',
  edit: 'Изменить',
  cancel: 'Отменить',
  save: 'Сохранить',
  connected_accounts: 'Подключенные кабинеты',
  connected_projects: 'Подключенные проекты',
  connect_account: 'Подключить кабинет',
  create_project: 'Создать проект',
  edit_project: 'Изменить проект',
  list_accounts: 'Кабинет',
  list_projects: 'Проект',
  marketplace: 'Маркетплейс',
  api_checked: 'Проверены API',
  assigned_project: 'Проект',
  employees_count: 'Сотрудников',
  user_role: 'Роль',
  status_label: 'Статус',
  actions: 'Действия',
  edit_account: 'Изменить',
  transfer_short: 'Передать',
  open_list: 'Открыть список',
  connect: 'Подключить',
  create: 'Создать',
  account_staff: 'Сотрудники кабинетов',
  project_staff: 'Сотрудники проектов',
  manage_cabinet_staff: 'Управление сотрудниками кабинета',
  manage_project_staff: 'Управление сотрудниками проекта',
  invite_employee: 'Пригласить сотрудника',
  invite_role_hint: 'Можно приглашать только на роль не выше своей. Управляющего приглашать нельзя.',
  list: 'Список',
  add: 'Добавить',
  update: 'Изменить',
  remove: 'Удалить',
  cabinets_count: 'Кабинетов',
  projects_count: 'проектов',
  connect_account_hint: 'Создайте новый кабинет или подключите существующий.',
  create_project_hint: 'Создайте новый проект для команды или клиента.',
  transfer_title: 'Передать в управление',
  account: 'Кабинет',
  project: 'Проект',
  account_id: 'ID кабинета',
  project_id: 'ID проекта',
  email: 'Email',
  email_or_id: 'Email или ID',
  transfer: 'Передать',
  transfer_requests: 'Запросы на передачу',
  accept: 'Принять',
  decline: 'Отклонить',
  invites: 'Приглашения',
  invite_email: 'Email сотрудника',
  member: 'Сотрудник',
  admin: 'Администратор',
  invite: 'Пригласить',
  billing_stub: 'Пока заглушка. Здесь будет управление тарифами и оплатой.',
  referral: 'Реферальная программа',
  your_code: 'Ваш код',
  invite_hint: 'Приглашайте коллег и получайте бонусы.',
  stats: 'Статистика',
  stats_total: 'Всего приглашений: 0',
  stats_active: 'Активных: 0',
  stats_pending: 'Ожидают: 0',
  support_stub: 'Пока заглушка. Здесь будет тикетная система и база знаний.',
  api_stub: 'Пока заглушка. Здесь будет управление токенами и лимитами.',
  agency_block: 'Агентство',
  agency_select: 'Аккредитованное агентство',
  agency_choose: 'Выбрать агентство',
  agency_request_title: 'Заявка на агентство',
  agency_request_submit: 'Оставить заявку',
  agency_request_pending: 'Заявка на рассмотрении.',
  agency_request_approved: 'Вы подтверждены как агентство.',
  agency_request_rejected: 'Заявка отклонена.',
  agency_request_comment: 'Комментарий администратора',
  agency_empty: 'Аккредитованных агентств пока нет.',
  agency_email: 'Email для связи',
  agency_phone: 'Телефон',
  agency_description: 'Комментарий',
  agency_selected: 'Агентство выбрано.',
  agency_select_error: 'Не удалось выбрать агентство.',
  agency_request_sent: 'Заявка отправлена.',
  company_saved: 'Данные плательщика обновлены.',
  company_save_error: 'Не удалось сохранить.',
  user_not_found: 'Пользователь с таким email не найден.',
  transfer_sent: 'Запрос на передачу создан.',
  transfer_accept: 'Запрос принят.',
  transfer_reject: 'Запрос отклонён.',
  transfer_error: 'Не удалось выполнить действие.',
  invite_empty: 'Нет приглашений',
  cabinet_invites: 'Приглашения в кабинеты',
  no_cabinets: 'Нет кабинетов',
  no_projects: 'Нет проектов',
  method: 'Способ',
  employee_id: 'ID сотрудника',
  role: 'Роль',
  no_employees: 'Нет сотрудников',
  project_invites: 'Приглашения в проекты',
  placeholder_cabinet: 'Выберите кабинет',
  placeholder_project: 'Выберите проект',
  no_project: 'Без проекта',
  billing_balance: 'Баланс',
  billing_plan: 'Текущий тариф',
  billing_status: 'Статус тарифа',
  billing_topup: 'Пополнение',
  billing_amount: 'Сумма',
  billing_description: 'Комментарий',
  billing_pay: 'Перейти к оплате',
  billing_pay_card: 'Оплатить картой',
  billing_pay_invoice: 'Тариф по счету',
  billing_invoice_amount: 'Сумма счета',
  billing_invoice_create: 'Сформировать счет',
  billing_invoices: 'Счета на оплату',
  billing_invoice_download: 'Скачать PDF',
  billing_invoices_empty: 'Счетов пока нет.',
  billing_storage_title: 'Облачное хранилище',
  billing_storage_included: 'Лимит входит в тариф',
  billing_storage_used: 'Использовано',
  billing_storage_overage: 'Превышение',
  billing_storage_empty: 'Данных по хранению пока нет.',
  billing_payer_title: 'Плательщик',
  billing_payer_hint: 'Реквизиты для выставления банковских счетов на оплату.',
  billing_payer_save: 'Сохранить плательщика',
  billing_payer_saved: 'Данные плательщика сохранены.',
  billing_payer_error: 'Не удалось сохранить плательщика.',
  billing_payer_required: 'Заполните данные плательщика.',
  promo_apply: 'Применить',
  promo_placeholder: 'PROMO2026',
  promo_active: 'Активный промокод',
  promo_applied: 'Промокод применен.',
  promo_apply_error: 'Не удалось применить промокод.',
  billing_transactions: 'История операций',
  billing_empty: 'Операций пока нет.',
  billing_loading: 'Загрузка биллинга...',
  promo_title: 'Промокод',
  promo_hint: 'Промокоды активируются через поддержку или админку.',
  referral_title: 'Реферальная программа',
  referral_code_title: 'Ваш ID промокода',
  referral_link_title: 'Ссылка для шаринга',
  referral_copy: 'Скопировать',
  referral_description: 'Описание бонусов',
  referral_apply_promo: 'Применить персональный промокод',
  referral_apply_promo_hint: 'Если вам выдали персональный промокод партнёра — введите его, чтобы получить индивидуальные условия',
  referral_stats_title: 'Статистика рефералов',
  referral_stat_links: 'Всего приглашённых',
  referral_stat_applied: 'Активных',
  referral_stat_income: 'Доступно к выводу',
  referral_stat_income_rub: '₽',
  referral_stat_balance: 'Всего начислено на вывод, ₽',
  referral_withdrawal: 'Заявка на вывод',
  referral_invites_title: 'Приглашения',
  referral_invites_empty: 'Пока нет приглашений.'
};
// TODO: временно скрыто, вернуть когда AI-настройки будут готовы (см. CLAUDE.md — минимальный обратимый флаг)
const SHOW_AI_SETTINGS_TAB = false;
const PLAN_LABELS = { free: 'Бесплатный', standard: 'Стандартный', full: 'Полный' };
const PLAN_PRICES = { free: '0 ₽', standard: '5 000 ₽/мес', full: '20 000 ₽/мес' };
const PLAN_ORDER = ['free', 'standard', 'full'];

function saveBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

function SettingsPanel() {
  const navigate = useNavigate();
  const {
    user,
    setUser
  } = useAuth();
  const {
    request,
    fetchBlob,
    authHeader,
    showStatus,
    setStatus,
    API_BASE_URL
  } = useApi();
  const companyContext = useCompany() || {};
  const {
    companyId,
    companyInfo,
    setCompanyInfo,
    settingsTab,
    setSettingsTab,
    setActiveSection,
    companyUsers = [],
    marketplaces = [],
    workspaces = [],
    memberships = [],
    accessRoles = [],
    accessAccountId,
    setAccessAccountId,
    accessForm,
    setAccessForm,
    accessIdentity,
    setAccessIdentity,
    accessBusy,
    handleAddMember,
    handleUpdateMember,
    handleCancelSentInvite,
    projectAccessWorkspaceId,
    setProjectAccessWorkspaceId,
    projectAccessMode,
    setProjectAccessMode,
    projectAccessIdentity,
    setProjectAccessIdentity,
    projectAccessRole,
    setProjectAccessRole,
    projectAccessBusy,
    handleAddProjectMember,
    handleUpdateProjectMember,
    getProjectAccessMembers,
    handleCabinetInviteAction,
    handleProjectInviteAction,
    cabinetInvites = [],
    sentCabinetInvites = [],
    projectInvites = [],
    ownershipTransfers = [],
    loadOwnershipTransfers,
    refreshMemberships,
    loadMarketplaces,
    loadWorkspaces,
    openProjectModal
  } = companyContext;
  const [onboardingBusy, setOnboardingBusy] = useState(false);
  const handleRestartOnboarding = async () => {
    setOnboardingBusy(true);
    try {
      const updated = await request('/api/v1/auth/me/onboarding', {
        method: 'PATCH',
        body: JSON.stringify({ completed: false })
      });
      if (updated && setUser) setUser(updated);
      showStatus('success', 'Тур запущен — откройте главную страницу');
    } catch (error) {
      showStatus('error', 'Не удалось запустить тур');
    } finally {
      setOnboardingBusy(false);
    }
  };
  const fallbackCompany = {
    name: '',
    inn: '',
    legal_address: ''
  };
  const company = companyInfo || fallbackCompany;
  const activeTab = (
    settingsTab === 'parser-agent' || (!SHOW_AI_SETTINGS_TAB && settingsTab === 'ai')
  ) ? 'cabinets' : (settingsTab || 'cabinets');
  const roleOptions = accessRoles.length ? accessRoles : ACCESS_ROLES;
  const safeAccessForm = accessForm || {
    role: 'manager'
  };
  const rolePriority = useMemo(() => ({
    owner: 5,
    admin_api: 4,
    admin: 3,
    manager: 2,
    finance: 1
  }), []);
  const [editingCompanyName, setEditingCompanyName] = useState(false);
  const [companyNameDraft, setCompanyNameDraft] = useState(company.name || '');
  const [companyInnDraft, setCompanyInnDraft] = useState(company.inn || '');
  const [companyAddressDraft, setCompanyAddressDraft] = useState(company.legal_address || '');
  const [marketplaceForm, setMarketplaceForm] = useState({
    marketplace_type: 'ozon',
    account_name: '',
    api_key: '',
    seller_id: '',
    client_id: '',
    client_secret: '',
    project_id: ''
  });
  const [marketplaceBusy, setMarketplaceBusy] = useState(false);
  const [agencyList, setAgencyList] = useState([]);
  const [agencySelectedId, setAgencySelectedId] = useState('');
  const [agencyForm, setAgencyForm] = useState({
    company_name: '',
    inn: '',
    contact_email: '',
    contact_phone: '',
    description: ''
  });
  const [agencyRequest, setAgencyRequest] = useState(null);
  const [agencyBusy, setAgencyBusy] = useState(false);
  const [editAccount, setEditAccount] = useState(null);
  const [editForm, setEditForm] = useState({
    account_name: '',
    api_key: '',
    client_id: '',
    client_secret: '',
    project_id: ''
  });
  const [editBusy, setEditBusy] = useState(false);
  const [manageCabinetBusy, setManageCabinetBusy] = useState(false);
  const [manageProjectBusy, setManageProjectBusy] = useState(false);
  const [ownershipBusy, setOwnershipBusy] = useState(false);
  const [transferCabinetId, setTransferCabinetId] = useState('');
  const [billingSummary, setBillingSummary] = useState(null);
  const [billingTransactions, setBillingTransactions] = useState([]);
  const [txTotal, setTxTotal] = useState(0);
  const [txOffset, setTxOffset] = useState(0);
  const [txBusy, setTxBusy] = useState(false);
  const [billingBusy, setBillingBusy] = useState(false);
  const [billingTopup, setBillingTopup] = useState({
    amount: '',
    description: ''
  });
  const [billingTopupBusy, setBillingTopupBusy] = useState(false);
  const [billingPayer, setBillingPayer] = useState(null);
  const [billingPayerForm, setBillingPayerForm] = useState({
    payer_name: '',
    inn: '',
    ogrn: '',
    address: '',
    bik: '',
    corr_account: '',
    settlement_account: ''
  });
  const [billingPayerBusy, setBillingPayerBusy] = useState(false);
  const [billingInvoice, setBillingInvoice] = useState({
    amount: '',
    description: ''
  });
  const [billingInvoiceBusy, setBillingInvoiceBusy] = useState(false);
  const [billingInvoices, setBillingInvoices] = useState([]);
  const [invoiceDocs, setInvoiceDocs] = useState({});
  const [billingPromoCode, setBillingPromoCode] = useState('');
  const [billingPromoBusy, setBillingPromoBusy] = useState(false);
  const [shopPlans, setShopPlans] = useState([]);
  const [shopPlansBusy, setShopPlansBusy] = useState(false);
  const [shopPlanChanging, setShopPlanChanging] = useState(null);
  const [storageUsage, setStorageUsage] = useState([]);
  const [storageBusy, setStorageBusy] = useState(false);
  const [referralStats, setReferralStats] = useState(null);
  const [referralParams, setReferralParams] = useState(null);
  const [referralBusy, setReferralBusy] = useState(false);
  const [referralAgentCode, setReferralAgentCode] = useState('');
  const [referralAgentCodeBusy, setReferralAgentCodeBusy] = useState(false);
  const [withdrawalRequests, setWithdrawalRequests] = useState([]);
  const [withdrawalBusy, setWithdrawalBusy] = useState(false);
  const [withdrawalForm, setWithdrawalForm] = useState({
    amount: '',
    recipient_name: '',
    inn: '',
    bik: '',
    account_number: '',
  });
  const [withdrawalError, setWithdrawalError] = useState('');
  const [withdrawalSuccess, setWithdrawalSuccess] = useState('');
  const [profileSummary, setProfileSummary] = useState(null);
  const [profileSummaryBusy, setProfileSummaryBusy] = useState(false);
  const [profileStats, setProfileStats] = useState(null);
  const [profileStatsBusy, setProfileStatsBusy] = useState(false);
  const [profileBusy, setProfileBusy] = useState(false);
  const [avatarBusy, setAvatarBusy] = useState(false);
  const [certificatesBusy, setCertificatesBusy] = useState(false);
  const [telegramBusy, setTelegramBusy] = useState(false);
  useEffect(() => {
    const saved = localStorage.getItem('withdrawalForm');
    if (saved) {
      try {
        setWithdrawalForm(JSON.parse(saved));
      } catch (e) {
        logger.error('Failed to load withdrawal form from localStorage', e);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('withdrawalForm', JSON.stringify(withdrawalForm));
  }, [withdrawalForm]);

  const storageIncludedTotal = useMemo(() => {
    const perShop = Number(billingSummary?.storage_included_gb_per_shop || 0);
    const count = Number(billingSummary?.shop_count || 0);
    return perShop * count;
  }, [billingSummary?.storage_included_gb_per_shop, billingSummary?.shop_count]);
  useEffect(() => {
    setCompanyNameDraft(company.name || '');
    setCompanyInnDraft(company.inn || '');
    setCompanyAddressDraft(company.legal_address || '');
  }, [company.name, company.inn, company.legal_address]);
  useEffect(() => {
    setAgencyForm(prev => ({
      ...prev,
      company_name: company.name || '',
      inn: company.inn || '',
      contact_email: user?.email || '',
      contact_phone: user?.phone || ''
    }));
  }, [company.name, company.inn, user?.email, user?.phone]);
  useEffect(() => {
    if (billingPayer) {
      setBillingPayerForm({
        payer_name: billingPayer.payer_name || '',
        inn: billingPayer.inn || '',
        ogrn: billingPayer.ogrn || '',
        address: billingPayer.address || '',
        bik: billingPayer.bik || '',
        corr_account: billingPayer.corr_account || '',
        settlement_account: billingPayer.settlement_account || ''
      });
      return;
    }
    setBillingPayerForm(prev => ({
      ...prev,
      payer_name: prev.payer_name || company.name || '',
      inn: prev.inn || company.inn || '',
      address: prev.address || company.legal_address || ''
    }));
  }, [billingPayer, company.name, company.inn, company.legal_address]);
  const inviteStatusMeta = {
    pending: {
      label: 'Ожидает',
      color: 'var(--status-warn-fg)',
      background: 'var(--status-warn-bg)'
    },
    accepted: {
      label: 'Принято',
      color: 'var(--status-ok-fg)',
      background: 'var(--status-ok-bg)'
    },
    active: {
      label: 'Принято',
      color: 'var(--status-ok-fg)',
      background: 'var(--status-ok-bg)'
    },
    rejected: {
      label: 'Отклонено',
      color: 'var(--status-bad-fg)',
      background: 'var(--status-bad-bg)'
    }
  };
  const getInviteStatusBadge = status => {
    const meta = inviteStatusMeta[status] || {
      label: status || '—',
      color: 'var(--ink-soft)',
      background: 'var(--control-bg)'
    };
    return <span style={{padding: '4px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: '600', color: meta.color, background: meta.background, whiteSpace: 'nowrap'}}>{meta.label}</span>;
  };
  const getRoleRank = role => rolePriority[role] || 0;
  const getAllowedRoles = currentRole => {
    const rank = getRoleRank(currentRole);
    if (!rank) return [];
    return roleOptions.filter(role => role.value !== 'owner' && getRoleRank(role.value) <= rank);
  };
  const getCabinetRoleLocal = accountId => getCabinetRole(accountId, marketplaces, normalizeId);
  const currentCabinetRole = useMemo(() => getCabinetRoleLocal(accessAccountId), [accessAccountId, marketplaces]);
  const cabinetRoleOptions = useMemo(() => getAllowedRoles(currentCabinetRole), [currentCabinetRole, roleOptions]);
  const currentProject = useMemo(() => workspaces.find(item => item.id === projectAccessWorkspaceId) || null, [workspaces, projectAccessWorkspaceId]);
  const currentProjectRole = useMemo(() => getWorkspaceRole(currentProject, user?.id, normalizeId), [currentProject, user?.id]);
  const projectRoleOptions = useMemo(() => getAllowedRoles(currentProjectRole), [currentProjectRole, roleOptions]);
  useEffect(() => {
    if (!cabinetRoleOptions.length || !setAccessForm) return;
    if (!cabinetRoleOptions.some(role => role.value === safeAccessForm.role)) {
      setAccessForm({
        ...safeAccessForm,
        role: cabinetRoleOptions[0].value
      });
    }
  }, [cabinetRoleOptions, safeAccessForm, setAccessForm]);
  useEffect(() => {
    if (!projectRoleOptions.length) return;
    if (!projectRoleOptions.some(role => role.value === projectAccessRole)) {
      setProjectAccessRole && setProjectAccessRole(projectRoleOptions[0].value);
    }
  }, [projectRoleOptions, projectAccessRole, setProjectAccessRole]);
  const cabinetProjectMap = useMemo(() => {
    const map = new Map();
    workspaces.forEach(workspace => {
      (workspace.cabinets || []).forEach(cabinet => {
        const key = normalizeId(cabinet.marketplace_account_id);
        if (!map.has(key)) {
          map.set(key, []);
        }
        map.get(key).push(workspace.name || workspace.id);
      });
    });
    return map;
  }, [workspaces]);
  const getCabinetProjects = accountId => {
    const list = cabinetProjectMap.get(normalizeId(accountId)) || [];
    return list.length ? list.join(', ') : '';
  };
  const getWorkspaceCabinetIds = workspace => (workspace.cabinets || []).map(cabinet => cabinet.marketplace_account_id);
  const getCabinetProjectIds = accountId => workspaces.filter(workspace => getWorkspaceCabinetIds(workspace).some(cabinetId => normalizeId(cabinetId) === normalizeId(accountId))).map(workspace => workspace.id);
  const getPrimaryCabinetProjectId = accountId => getCabinetProjectIds(accountId)[0] || '';
  const ownedCabinets = useMemo(() => marketplaces.filter(item => getCabinetRoleLocal(item.id) === 'owner'), [marketplaces]);
  const ownedProjects = useMemo(() => workspaces.filter(item => item.owner_user_id && normalizeId(item.owner_user_id) === normalizeId(user?.id)), [workspaces, user?.id]);
  const inviteableCabinets = useMemo(() => marketplaces.filter(item => getRoleRank(getCabinetRoleLocal(item.id)) > 0), [marketplaces]);
  const inviteableProjects = useMemo(() => workspaces.filter(item => getRoleRank(getWorkspaceRole(item, user?.id, normalizeId)) > 0), [workspaces, user?.id]);
  useEffect(() => {
    if (!inviteableCabinets.length || !setAccessAccountId) return;
    const hasCurrent = inviteableCabinets.some(item => item.id === accessAccountId);
    if (!hasCurrent) {
      setAccessAccountId(inviteableCabinets[0].id);
    }
  }, [inviteableCabinets, accessAccountId, setAccessAccountId]);
  useEffect(() => {
    if (!inviteableProjects.length || !setProjectAccessWorkspaceId) return;
    const hasCurrent = inviteableProjects.some(item => item.id === projectAccessWorkspaceId);
    if (!hasCurrent) {
      setProjectAccessWorkspaceId(inviteableProjects[0].id);
    }
  }, [inviteableProjects, projectAccessWorkspaceId, setProjectAccessWorkspaceId]);
  const updateAccessRole = role => {
    if (!setAccessForm) return;
    setAccessForm({
      ...safeAccessForm,
      role
    });
  };
  const handleAddMemberSafe = handleAddMember || (event => event.preventDefault());
  const handleAddProjectMemberSafe = handleAddProjectMember || (event => event.preventDefault());
  const openEditAccount = account => {
    openEditAccountBase(account, setEditAccount, setEditForm);
    const projectId = getPrimaryCabinetProjectId(account.id);
    setEditForm(prev => ({
      ...prev,
      project_id: projectId
    }));
  };
  const closeEditAccount = () => closeEditAccountBase(setEditAccount, setEditForm);
  const editAccountRole = editAccount ? getCabinetRoleLocal(editAccount.id) : '';
  const canEditProject = editAccountRole === 'owner';
  const canEditName = editAccountRole === 'owner';
  const canManageSelectedCabinet = ['owner', 'admin', 'admin_api'].includes(currentCabinetRole);
  const canManageSelectedProject = ['owner', 'admin', 'admin_api'].includes(currentProjectRole);
  const copyText = async text => {
    if (!text) return;
    try {
      const copied = await copyToClipboard(text);
      if (!copied) {
        throw new Error('copy_failed');
      }
      showStatus('success', t.copied);
    } catch (error) {
      logger.error(error);
      showStatus('error', t.copy_fail);
    }
  };
  const handleProfileSave = payload => handleProfileSaveBase({
    payload,
    user,
    request,
    setProfileBusy,
    setStatus,
    setUser,
    showStatus,
    loadProfileSummary: () => loadProfileSummary(request, user?.id, setProfileSummary, setProfileSummaryBusy),
    loadProfileStats: () => loadProfileStatsBase(request, user?.id, setProfileStats, setProfileStatsBusy)
  });
  const handleAvatarUpload = file => handleAvatarUploadBase({
    file,
    user,
    apiBaseUrl: API_BASE_URL,
    authHeader,
    setAvatarBusy,
    setUser,
    showStatus
  });
  const handleCertificatesUpload = files => handleCertificatesUploadBase({
    files,
    user,
    apiBaseUrl: API_BASE_URL,
    authHeader,
    setCertificatesBusy,
    setUser,
    showStatus
  });
  const handleTelegramLink = () => handleTelegramLinkBase({
    user,
    request,
    setTelegramBusy,
    showStatus
  });
  const formatMoney = (value, currency = 'RUB') => {
    if (value == null || value === '') return '—';
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return `${value} ${currency}`;
    return `${numeric.toLocaleString('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} ${currency}`;
  };
  const formatStorage = value => {
    if (value == null || value === '') return '—';
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return `${value} ГБ`;
    return `${numeric.toLocaleString('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} ГБ`;
  };
  const formatDateTime = value => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleString('ru-RU');
  };
  const formatPlan = value => {
    const labels = {
      free: 'Free',
      basic: 'Basic',
      pro: 'Pro',
      enterprise: 'Enterprise'
    };
    return labels[value] || value || '—';
  };
  const formatPlanStatus = value => {
    const labels = {
      active: 'Активен',
      suspended: 'Приостановлен',
      cancelled: 'Отменён'
    };
    return labels[value] || value || '—';
  };
  const formatTransactionType = value => {
    const labels = {
      topup: 'Пополнение',
      charge: 'Списание',
      refund: 'Возврат',
      invoice: 'Счет',
      storage: 'Хранение'
    };
    return labels[value] || value || '—';
  };
  const formatTransactionComment = tx => {
    if (tx.description) return tx.description;
    const defaults = {
      topup: 'Пополнение баланса',
      charge: 'Списание за услуги',
      refund: 'Возврат средств',
      invoice: 'Оплата по счету',
      storage: 'Оплата хранения',
      vitrine_check: 'Проверка витрины'
    };
    return defaults[tx.transaction_type] || '—';
  };
  const formatTransactionStatus = value => {
    const labels = {
      pending: 'В обработке',
      succeeded: 'Успешно',
      failed: 'Ошибка',
      issued: 'Выставлен',
      paid: 'Оплачен',
      cancelled: 'Отменен'
    };
    return labels[value] || value || '—';
  };
  const loadTransactionsPage = async (offset) => {
    setTxBusy(true);
    try {
      const data = await request(`/api/v1/billing/transactions/page?limit=${TX_PAGE}&offset=${offset}`);
      setBillingTransactions(data?.items || []);
      setTxTotal(data?.total || 0);
      setTxOffset(offset);
    } catch (error) {
      showStatus('error', 'Не удалось загрузить операции');
    } finally {
      setTxBusy(false);
    }
  };
  const downloadTransactions = async () => {
    try {
      const blob = await fetchBlob('/api/v1/billing/transactions/export');
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'billing_history.csv';
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      showStatus('error', 'Не удалось скачать историю операций');
    }
  };
  const loadBilling = async () => {
    setBillingBusy(true);
    setStorageBusy(true);
    setShopPlansBusy(true);
    try {
      const parts = await Promise.allSettled([
        request('/api/v1/billing/summary'),
        request(`/api/v1/billing/transactions/page?limit=${TX_PAGE}&offset=0`),
        request('/api/v1/billing/payer'),
        request('/api/v1/billing/invoices'),
        request('/api/v1/billing/storage'),
        request('/api/v1/billing/shops'),
      ]);
      const failedParts = ['баланс', 'операции', 'плательщик', 'счета', 'хранилище', 'тарифы магазинов']
        .filter((_, index) => parts[index].status === 'rejected');
      if (failedParts.length) showStatus('error', `Не загрузилось: ${failedParts.join(', ')}. Остальное показано.`);
      const [summary, transactions, payer, invoices, storage, shops] = parts.map(part => (
        part.status === 'fulfilled' ? part.value : null
      ));
      setBillingSummary(summary);
      setBillingTransactions(transactions?.items || []);
      setTxTotal(transactions?.total || 0);
      setTxOffset(0);
      setBillingPayer(payer || null);
      const invList = invoices || [];
      setBillingInvoices(invList);
      if (invList.length > 0) {
        const docsMap = {};
        await Promise.all(invList.map(async inv => {
          try {
            const docs = await request(`/api/v1/billing/invoices/${inv.id}/closing-docs`);
            if (docs && docs.length > 0) docsMap[inv.id] = docs;
          } catch (e) {
            logger.error(`Failed to load docs for invoice ${inv.id}:`, e);
          }
        }));
        setInvoiceDocs(docsMap);
      }
      setStorageUsage(storage || []);
      setShopPlans(shops || []);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Ошибка загрузки данных биллинга.');
    } finally {
      setBillingBusy(false);
      setStorageBusy(false);
      setShopPlansBusy(false);
    }
  };

  const handleShopPlanChange = async (accountId, newPlan) => {
    if (!window.confirm(`Сменить тариф на «${PLAN_LABELS[newPlan] || newPlan}»?`)) return;
    setShopPlanChanging(accountId);
    try {
      const updated = await request(`/api/v1/billing/shops/${accountId}/plan`, {
        method: 'POST',
        body: JSON.stringify({ plan_type: newPlan }),
      });
      setShopPlans(prev => prev.map(s => s.account_id === accountId ? updated : s));
      showStatus('success', 'Тариф обновлён.');
    } catch (err) {
      showStatus('error', err?.detail || 'Ошибка смены тарифа.');
    } finally {
      setShopPlanChanging(null);
    }
  };
  const handleBillingTopup = async event => {
    event.preventDefault();
    const amountValue = Number(String(billingTopup.amount).replace(',', '.'));
    if (!amountValue || Number.isNaN(amountValue) || amountValue <= 0) {
      showStatus('error', 'Введите сумму пополнения.');
      return;
    }
    setBillingTopupBusy(true);
    try {
      const payload = {
        amount: amountValue,
        description: billingTopup.description?.trim() || null
      };
      const result = await request('/api/v1/billing/topup', {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      showStatus('success', 'Создано пополнение. Перейдите к оплате.');
      if (result?.confirmation_url) {
        window.open(result.confirmation_url, '_blank', 'noopener,noreferrer');
      }
      setBillingTopup({
        amount: '',
        description: ''
      });
      await loadBilling();
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось создать пополнение.');
    } finally {
      setBillingTopupBusy(false);
    }
  };
  const loadReferrals = async () => {
    setReferralBusy(true);
    try {
      const [stats, params] = await Promise.all([
        request('/api/v1/referrals'),
        request('/api/v1/referrals/my-params')
      ]);
      setReferralStats(stats);
      setReferralParams(params);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось загрузить рефералы.');
    } finally {
      setReferralBusy(false);
    }
  };
  const handleApplyAgentPromo = async event => {
    event.preventDefault();
    const code = referralAgentCode.trim();
    if (!code) {
      showStatus('error', 'Введите промокод');
      return;
    }
    setReferralAgentCodeBusy(true);
    try {
      await request('/api/v1/referrals/apply-promo', {
        method: 'POST',
        body: JSON.stringify({ code })
      });
      showStatus('success', 'Персональный промокод активирован — условия рефералки обновлены.');
      setReferralAgentCode('');
      await loadReferrals();
    } catch (error) {
      logger.error(error);
      showStatus('error', error?.message || 'Не удалось применить промокод. Проверьте код.');
    } finally {
      setReferralAgentCodeBusy(false);
    }
  };

  const loadWithdrawals = async () => {
    setWithdrawalBusy(true);
    try {
      const withdrawals = await request('/api/v1/referrals/withdrawal-requests');
      setWithdrawalRequests(withdrawals);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось загрузить заявки на вывод.');
    } finally {
      setWithdrawalBusy(false);
    }
  };

  const handleWithdrawalChange = e => {
    const { name, value } = e.target;
    setWithdrawalForm(f => ({ ...f, [name]: value }));
  };

  const handleWithdrawalSubmit = async event => {
    event.preventDefault();
    setWithdrawalError('');
    setWithdrawalSuccess('');

    if (!withdrawalForm.amount || !withdrawalForm.recipient_name || !withdrawalForm.inn || !withdrawalForm.bik || !withdrawalForm.account_number) {
      setWithdrawalError('Заполните все поля');
      return;
    }

    setWithdrawalBusy(true);
    try {
      await request('/api/v1/referrals/withdrawal-request', {
        method: 'POST',
        body: JSON.stringify({
          amount: parseFloat(withdrawalForm.amount),
          recipient_name: withdrawalForm.recipient_name,
          inn: withdrawalForm.inn,
          bik: withdrawalForm.bik,
          account_number: withdrawalForm.account_number,
        })
      });
      setWithdrawalSuccess('Заявка создана. Вывод денег будет обработан администратором.');
      setWithdrawalForm({
        amount: '',
        recipient_name: '',
        inn: '',
        bik: '',
        account_number: '',
      });
      await loadWithdrawals();
    } catch (error) {
      logger.error(error);
      setWithdrawalError(error?.detail || 'Не удалось создать заявку на вывод.');
    } finally {
      setWithdrawalBusy(false);
    }
  };

  const handlePromoApply = async event => {
    event.preventDefault();
    const code = billingPromoCode.trim();
    if (!code) {
      showStatus('error', t.promo_apply_error);
      return;
    }
    setBillingPromoBusy(true);
    try {
      await request('/api/v1/billing/promocode/apply', {
        method: 'POST',
        body: JSON.stringify({
          code
        })
      });
      showStatus('success', t.promo_applied);
      setBillingPromoCode('');
      await loadBilling();
    } catch (error) {
      logger.error(error);
      showStatus('error', error?.message || t.promo_apply_error);
    } finally {
      setBillingPromoBusy(false);
    }
  };
  const handlePayerSave = async event => {
    event.preventDefault();
    const requiredFields = ['payer_name', 'inn', 'ogrn', 'address', 'bik', 'corr_account', 'settlement_account'];
    if (requiredFields.some(key => !billingPayerForm[key])) {
      showStatus('error', t.billing_payer_required);
      return;
    }
    setBillingPayerBusy(true);
    try {
      const result = await request('/api/v1/billing/payer', {
        method: 'PUT',
        body: JSON.stringify(billingPayerForm)
      });
      setBillingPayer(result);
      let companyData;
      try {
        companyData = await request('/api/v1/companies/me', {
          method: 'PATCH',
          body: JSON.stringify({
            name: billingPayerForm.payer_name,
            inn: billingPayerForm.inn,
            legal_address: billingPayerForm.address
          })
        });
      } catch (companyError) {
        showStatus('error', 'Реквизиты плательщика сохранены, но название/ИНН в профиле не обновились: ' + (companyError?.message || ''));
        return;
      }
      if (setCompanyInfo) setCompanyInfo(companyData);
      setCompanyNameDraft(billingPayerForm.payer_name);
      setCompanyInnDraft(billingPayerForm.inn);
      setCompanyAddressDraft(billingPayerForm.address);
      showStatus('success', t.billing_payer_saved);
    } catch (error) {
      logger.error(error);
      showStatus('error', error?.message || t.billing_payer_error);
    } finally {
      setBillingPayerBusy(false);
    }
  };
  const handleInvoiceCreate = async event => {
    event.preventDefault();
    const amountValue = Number(String(billingInvoice.amount).replace(',', '.'));
    if (!amountValue || Number.isNaN(amountValue) || amountValue <= 0) {
      showStatus('error', 'Введите сумму счета.');
      return;
    }
    setBillingInvoiceBusy(true);
    try {
      await request('/api/v1/billing/invoices', {
        method: 'POST',
        body: JSON.stringify({
          amount: amountValue,
          description: billingInvoice.description?.trim() || null
        })
      });
      showStatus('success', 'Счет сформирован.');
      setBillingInvoice({
        amount: '',
        description: ''
      });
      await loadBilling();
    } catch (error) {
      logger.error(error);
      showStatus('error', error?.message || 'Не удалось сформировать счет.');
    } finally {
      setBillingInvoiceBusy(false);
    }
  };
  const handleInvoiceDownload = async (invoiceId, invoiceNumber) => {
    if (!invoiceId) return;
    try {
      const blob = await fetchBlob(`/api/v1/billing/invoices/${invoiceId}/download`);
      saveBlob(blob, `${invoiceNumber || invoiceId}.pdf`);
    } catch (e) {
      logger.error('Invoice download failed:', e);
      showStatus('error', 'Не удалось скачать счёт: ' + (e?.message || ''));
    }
  };
  useEffect(() => {
    if (activeTab === 'billing') {
      loadBilling();
    }
  }, [activeTab]);
  useEffect(() => {
    if (activeTab === 'referral') {
      loadReferrals();
      loadWithdrawals();
    }
  }, [activeTab]);
  useEffect(() => {
    if (activeTab !== 'account') return;
    if (!user?.id) return;
    loadProfileSummary(request, user.id, setProfileSummary, setProfileSummaryBusy).catch(error => {
      logger.error(error);
    });
    loadProfileStatsBase(request, user.id, setProfileStats, setProfileStatsBusy).catch(error => {
      logger.error(error);
    });
  }, [activeTab, request, user?.id]);
  const syncCabinetProject = async (accountId, targetProjectId) => {
    if (!accountId || !workspaces.length) return;
    const normalizedAccountId = normalizeId(accountId);
    const targetId = targetProjectId ? normalizeId(targetProjectId) : '';
    const updates = workspaces.flatMap(workspace => {
      const currentIds = getWorkspaceCabinetIds(workspace);
      const hasCurrent = currentIds.some(cabinetId => normalizeId(cabinetId) === normalizedAccountId);
      const shouldHave = targetId && normalizeId(workspace.id) === targetId;
      if (hasCurrent === Boolean(shouldHave)) return [];
      const nextIds = currentIds.filter(cabinetId => normalizeId(cabinetId) !== normalizedAccountId);
      if (shouldHave) {
        nextIds.push(accountId);
      }
      return [request(`/api/v1/workspaces/${workspace.id}`, {
        method: 'PATCH',
        body: JSON.stringify({
          cabinet_ids: nextIds
        })
      })];
    });
    if (!updates.length) return;
    await Promise.all(updates);
    loadWorkspaces && (await loadWorkspaces());
  };
  const handleMarketplaceSubmit = event => {
    const trimmedName = marketplaceForm.account_name.trim().toLowerCase();
    if (trimmedName) {
      const hasDuplicate = marketplaces.some(item => item.marketplace_type === marketplaceForm.marketplace_type && (item.account_name || '').trim().toLowerCase() === trimmedName);
      if (hasDuplicate) {
        showStatus('error', 'Кабинет с таким названием уже подключен.');
        event.preventDefault();
        return;
      }
    }

    // Если выбран "Без проекта" - проверить что нет дубля имени проекта
    if (!marketplaceForm.project_id) {
      const projectNameToCreate = marketplaceForm.account_name.trim();
      const projectWithSameName = workspaces.some(ws => ws.name && ws.name.trim().toLowerCase() === projectNameToCreate.toLowerCase());
      if (projectWithSameName) {
        showStatus('error', `Проект с названием "${projectNameToCreate}" уже существует. Выберите другое имя для кабинета или существующий проект.`);
        event.preventDefault();
        return;
      }
    }

    return handleMarketplaceSubmitBase({
      event,
      companyId,
      marketplaceForm,
      request,
      setBusy: setMarketplaceBusy,
      setStatus,
      showStatus,
      setMarketplaceForm,
      initialMarketplace: {
        marketplace_type: 'ozon',
        account_name: '',
        api_key: '',
        seller_id: '',
        client_id: '',
        client_secret: '',
        project_id: ''
      },
      loadMarketplaces,
      onCreated: async account => {
        if (marketplaceForm.project_id) {
          await syncCabinetProject(account.id, marketplaceForm.project_id);
        } else if (loadWorkspaces) {
          // Бэкенд создал личный проект кабинета — подтянуть его в список.
          await loadWorkspaces();
        }
      }
    });
  };
  const handleEditSubmit = async event => {
    const result = await handleEditSubmitBase({
      event,
      editAccount,
      editForm,
      request,
      setEditBusy,
      setStatus,
      showStatus,
      loadMarketplaces,
      closeEditAccount,
      companyId,
      returnResult: true
    });
    if (result?.updated && editAccount) {
      await syncCabinetProject(editAccount.id, editForm.project_id);
    }
  };
  const handleDeleteAccount = async (accountId, confirmName) => {
    setEditBusy(true);
    setStatus(null);
    try {
      await request(`/api/v1/marketplaces/${accountId}?confirm_name=${encodeURIComponent(confirmName || '')}`, {
        method: 'DELETE',
        silent: true
      });
      // Reload marketplaces list
      await (loadMarketplaces ? loadMarketplaces(companyId) : Promise.resolve());
      showStatus('success', 'Кабинет удален.');
      closeEditAccount();
      return { ok: true };
    } catch (error) {
      logger.error(error);
      // Причину (нет подтверждения названием, в кабинете есть данные) показываем в окне подтверждения.
      return { ok: false, error: error?.message || 'Не удалось удалить кабинет.' };
    } finally {
      setEditBusy(false);
    }
  };
  const getWorkspaceById = workspaceId => workspaces.find(item => item.id === workspaceId) || null;
  const getCabinetById = cabinetId => marketplaces.find(item => normalizeId(item.id) === normalizeId(cabinetId)) || null;
  const getCabinetName = cabinetId => {
    const cabinet = getCabinetById(cabinetId);
    return cabinet?.account_name || cabinet?.name || cabinetId;
  };
  const getProjectCabinetIds = workspaceId => {
    const workspace = getWorkspaceById(workspaceId);
    return workspace ? getWorkspaceCabinetIds(workspace) : [];
  };
  const getCabinetIdsForProjects = projectIds => {
    const ids = new Set();
    projectIds.forEach(projectId => {
      getProjectCabinetIds(projectId).forEach(cabinetId => ids.add(cabinetId));
    });
    return Array.from(ids);
  };
  const fetchCabinetMemberships = async cabinetId => request(`/api/v1/access/marketplaces/${cabinetId}/memberships`, {});
  const findCabinetMember = (members, userId) => members.find(member => normalizeId(member.user?.id) === normalizeId(userId));
  const updateCabinetMemberRole = async (cabinetId, userId, role) => {
    const members = await fetchCabinetMemberships(cabinetId);
    const membership = findCabinetMember(members, userId);
    if (!membership) return;
    await request(`/api/v1/access/memberships/${membership.id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        role
      })
    });
  };
  const removeCabinetMember = async (cabinetId, userId) => {
    const members = await fetchCabinetMemberships(cabinetId);
    const membership = findCabinetMember(members, userId);
    if (!membership) return;
    await request(`/api/v1/access/memberships/${membership.id}`, {
      method: 'DELETE'
    });
  };
  const updateWorkspaceMembers = async (workspace, members) => request(`/api/v1/workspaces/${workspace.id}`, {
    method: 'PATCH',
    body: JSON.stringify({
      member_ids: members
    })
  });
  const syncProjectMemberRole = async (workspace, userId, role) => {
    const currentMembers = workspace.members || [];
    const exists = currentMembers.some(member => normalizeId(member.user_id) === normalizeId(userId));
    const nextMembers = exists ? currentMembers.map(member => ({
      user_id: member.user_id,
      role: normalizeId(member.user_id) === normalizeId(userId) ? role : member.role
    })) : [...currentMembers, {
      user_id: userId,
      role
    }];
    await updateWorkspaceMembers(workspace, nextMembers);
  };
  const syncProjectMemberRemoval = async (workspace, userId) => {
    const currentMembers = workspace.members || [];
    const nextMembers = currentMembers.filter(member => normalizeId(member.user_id) !== normalizeId(userId));
    await updateWorkspaceMembers(workspace, nextMembers);
  };
  const handleCabinetMemberRoleChange = async (membership, role) => {
    let syncIncomplete = false;
    if (!membership?.id || !accessAccountId) return;
    if (!canManageSelectedCabinet) {
      showStatus('error', 'Недостаточно прав для управления кабинетом.');
      return;
    }
    if (membership.role === 'owner') return;
    if (getRoleRank(membership.role) > getRoleRank(currentCabinetRole)) {
      showStatus('error', 'Нельзя изменить роль сотрудника с более высоким уровнем доступа.');
      return;
    }
    setManageCabinetBusy(true);
    setStatus(null);
    try {
      await request(`/api/v1/access/memberships/${membership.id}`, {
        method: 'PATCH',
        body: JSON.stringify({
          role
        })
      });
      await (refreshMemberships ? refreshMemberships() : Promise.resolve());
      const projectIds = getCabinetProjectIds(accessAccountId);
      if (projectIds.length) {
        const relatedCabinetIds = getCabinetIdsForProjects(projectIds);
        const manageableIds = relatedCabinetIds.filter(cabinetId => ['owner', 'admin', 'admin_api'].includes(getCabinetRoleLocal(cabinetId)));
        if (manageableIds.length !== relatedCabinetIds.length) {
          syncIncomplete = true;
          showStatus('error', 'В этом кабинете изменено, но в остальных кабинетах проекта — нет: недостаточно прав. Попросите владельца проекта.');
        } else {
          await Promise.all(manageableIds.map(cabinetId => updateCabinetMemberRole(cabinetId, membership.user?.id, role)));
          await Promise.all(projectIds.map(projectId => {
            const workspace = getWorkspaceById(projectId);
            return workspace ? syncProjectMemberRole(workspace, membership.user?.id, role) : null;
          }));
          await (loadWorkspaces ? loadWorkspaces() : Promise.resolve());
        }
      }
      if (!syncIncomplete) showStatus('success', 'Роль обновлена.');
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось обновить роль.');
    } finally {
      setManageCabinetBusy(false);
    }
  };
  const handleCabinetMemberRemove = async membership => {
    let syncIncomplete = false;
    if (!membership?.id || !accessAccountId) return;
    if (!canManageSelectedCabinet) {
      showStatus('error', 'Недостаточно прав для управления кабинетом.');
      return;
    }
    if (membership.role === 'owner') return;
    if (getRoleRank(membership.role) > getRoleRank(currentCabinetRole)) {
      showStatus('error', 'Нельзя удалить сотрудника с более высоким уровнем доступа.');
      return;
    }
    const projectIds = getCabinetProjectIds(accessAccountId);
    const projectNames = projectIds.map(projectId => getWorkspaceById(projectId)?.name || projectId).join(', ');
    const relatedCabinetIds = getCabinetIdsForProjects(projectIds);
    const relatedCabinetNames = relatedCabinetIds.map(getCabinetName).join(', ');
    const cabinetLabel = getCabinetName(accessAccountId);
    const confirmMessage = projectIds.length ? `Удалить сотрудника из кабинета "${cabinetLabel}" и проектов: ${projectNames || 'без названий'}. Кабинеты проектов: ${relatedCabinetNames || 'нет'}.` : `Удалить сотрудника из кабинета "${cabinetLabel}"?`;
    if (!window.confirm(confirmMessage)) {
      return;
    }
    setManageCabinetBusy(true);
    setStatus(null);
    try {
      await request(`/api/v1/access/memberships/${membership.id}`, {
        method: 'DELETE'
      });
      await (refreshMemberships ? refreshMemberships() : Promise.resolve());
      const projectIds = getCabinetProjectIds(accessAccountId);
      if (projectIds.length) {
        const relatedCabinetIds = getCabinetIdsForProjects(projectIds);
        const manageableIds = relatedCabinetIds.filter(cabinetId => ['owner', 'admin', 'admin_api'].includes(getCabinetRoleLocal(cabinetId)));
        if (manageableIds.length !== relatedCabinetIds.length) {
          syncIncomplete = true;
          showStatus('error', 'В этом кабинете изменено, но в остальных кабинетах проекта — нет: недостаточно прав. Попросите владельца проекта.');
        } else {
          await Promise.all(manageableIds.map(cabinetId => removeCabinetMember(cabinetId, membership.user?.id)));
          await Promise.all(projectIds.map(projectId => {
            const workspace = getWorkspaceById(projectId);
            return workspace ? syncProjectMemberRemoval(workspace, membership.user?.id) : null;
          }));
          await (loadWorkspaces ? loadWorkspaces() : Promise.resolve());
        }
      }
      if (!syncIncomplete) showStatus('success', 'Сотрудник удален.');
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось удалить сотрудника.');
    } finally {
      setManageCabinetBusy(false);
    }
  };
  const handleProjectMemberRoleChange = async (member, role) => {
    let syncIncomplete = false;
    if (!currentProject || !member?.user_id) return;
    if (!canManageSelectedProject) {
      showStatus('error', 'Недостаточно прав для управления проектом.');
      return;
    }
    if (normalizeId(member.user_id) === normalizeId(currentProject.owner_user_id)) return;
    if (getRoleRank(member.role) > getRoleRank(currentProjectRole)) {
      showStatus('error', 'Нельзя изменить роль сотрудника с более высоким уровнем доступа.');
      return;
    }
    setManageProjectBusy(true);
    setStatus(null);
    try {
      await syncProjectMemberRole(currentProject, member.user_id, role);
      const cabinetIds = getWorkspaceCabinetIds(currentProject);
      const manageableIds = cabinetIds.filter(cabinetId => ['owner', 'admin', 'admin_api'].includes(getCabinetRoleLocal(cabinetId)));
      if (manageableIds.length !== cabinetIds.length) {
        syncIncomplete = true;
        showStatus('error', 'В проекте изменено, но не во всех его кабинетах: недостаточно прав. Попросите владельца кабинетов.');
      } else {
        await Promise.all(manageableIds.map(cabinetId => updateCabinetMemberRole(cabinetId, member.user_id, role)));
        await (loadWorkspaces ? loadWorkspaces() : Promise.resolve());
      }
      if (!syncIncomplete) showStatus('success', 'Роль обновлена.');
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось обновить роль.');
    } finally {
      setManageProjectBusy(false);
    }
  };
  const handleProjectMemberRemove = async member => {
    let syncIncomplete = false;
    if (!currentProject || !member?.user_id) return;
    if (!canManageSelectedProject) {
      showStatus('error', 'Недостаточно прав для управления проектом.');
      return;
    }
    if (normalizeId(member.user_id) === normalizeId(currentProject.owner_user_id)) return;
    if (getRoleRank(member.role) > getRoleRank(currentProjectRole)) {
      showStatus('error', 'Нельзя удалить сотрудника с более высоким уровнем доступа.');
      return;
    }
    const cabinetIds = getWorkspaceCabinetIds(currentProject);
    const cabinetNames = cabinetIds.map(getCabinetName).join(', ');
    const projectLabel = currentProject.name || currentProject.id;
    const confirmMessage = cabinetIds.length ? `Удалить сотрудника из проекта "${projectLabel}" и кабинетов: ${cabinetNames || 'нет'}.` : `Удалить сотрудника из проекта "${projectLabel}"?`;
    if (!window.confirm(confirmMessage)) {
      return;
    }
    setManageProjectBusy(true);
    setStatus(null);
    try {
      await syncProjectMemberRemoval(currentProject, member.user_id);
      const cabinetIds = getWorkspaceCabinetIds(currentProject);
      const manageableIds = cabinetIds.filter(cabinetId => ['owner', 'admin', 'admin_api'].includes(getCabinetRoleLocal(cabinetId)));
      if (manageableIds.length !== cabinetIds.length) {
        syncIncomplete = true;
        showStatus('error', 'Из проекта удалён, но не из всех его кабинетов: недостаточно прав. Попросите владельца кабинетов.');
      } else {
        await Promise.all(manageableIds.map(cabinetId => removeCabinetMember(cabinetId, member.user_id)));
        await (loadWorkspaces ? loadWorkspaces() : Promise.resolve());
      }
      if (!syncIncomplete) showStatus('success', 'Сотрудник удален.');
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось удалить сотрудника.');
    } finally {
      setManageProjectBusy(false);
    }
  };
  const handleSaveCompany = async () => {
    try {
      setStatus(null);
      const data = await request('/api/v1/companies/me', {
        method: 'PATCH',
        body: JSON.stringify({
          name: companyNameDraft,
          inn: companyInnDraft,
          legal_address: companyAddressDraft
        })
      });
      if (setCompanyInfo) {
        setCompanyInfo(data);
      }
      setEditingCompanyName(false);
      showStatus('success', t.company_saved);
    } catch (error) {
      logger.error(error);
      showStatus('error', t.company_save_error);
    }
  };
  const createTransfer = async (scopeType, scopeId, recipientId, clear) => {
    if (!scopeId || !recipientId) return;
    setOwnershipBusy(true);
    setStatus(null);
    try {
      await request('/api/v1/ownership-transfers/', {
        method: 'POST',
        body: JSON.stringify({
          scope_type: scopeType,
          scope_id: scopeId,
          to_user_id: recipientId
        })
      });
      clear();
      if (loadOwnershipTransfers) {
        await loadOwnershipTransfers();
      }
      showStatus('success', t.transfer_sent);
    } catch (error) {
      logger.error(error);
      showStatus('error', t.transfer_error);
    } finally {
      setOwnershipBusy(false);
    }
  };
  const handleTransferAction = async (transferId, action) => {
    if (!transferId) return;
    setOwnershipBusy(true);
    setStatus(null);
    try {
      await request(`/api/v1/ownership-transfers/${transferId}/${action}`, {
        method: 'POST'
      });
      if (loadOwnershipTransfers) {
        await loadOwnershipTransfers();
      }
      if (action === 'accept') {
        if (loadMarketplaces) await loadMarketplaces();
        if (loadWorkspaces) await loadWorkspaces();
      }
      showStatus('success', action === 'accept' ? t.transfer_accept : t.transfer_reject);
    } catch (error) {
      logger.error(error);
      showStatus('error', t.transfer_error);
    } finally {
      setOwnershipBusy(false);
    }
  };
  const handleCabinetInvite = async (inviteId, action) => {
    if (handleCabinetInviteAction) {
      return handleCabinetInviteAction(inviteId, action);
    }
    try {
      await request(`/api/v1/invitations/me/${inviteId}/${action}`, {
        method: 'POST'
      });
      showStatus('success', action === 'accept' ? t.transfer_accept : t.transfer_reject);
    } catch (error) {
      logger.error(error);
      showStatus('error', t.transfer_error);
    }
  };
  const handleProjectInvite = async (inviteId, action) => {
    if (handleProjectInviteAction) {
      return handleProjectInviteAction(inviteId, action);
    }
    try {
      await request(`/api/v1/workspaces/invites/${inviteId}/${action}`, {
        method: 'POST'
      });
      showStatus('success', action === 'accept' ? t.transfer_accept : t.transfer_reject);
    } catch (error) {
      logger.error(error);
      showStatus('error', t.transfer_error);
    }
  };
  // Сотрудник в списках: «Фамилия Имя» и почта (если имени нет — только почта).
  const renderMemberIdentity = (memberUser, fallbackId) => {
    const fullName = formatUserFullName(memberUser);
    const email = memberUser?.email || '';
    return <>
                <div style={{fontWeight: '500', fontSize: '14px'}}>{fullName || email || fallbackId}</div>
                {fullName && email && <div style={{fontSize: '12px', color: 'var(--ink-soft)'}}>{email}</div>}
            </>;
  };
  const transferCabinet = transferCabinetId ? marketplaces.find(item => normalizeId(item.id) === normalizeId(transferCabinetId)) : null;
  const getTransferScopeLabel = transfer => {
    const kind = transfer.scope_type === 'cabinet' ? 'Кабинет' : 'Проект';
    let name = transfer.scope_name;
    if (!name && transfer.scope_type === 'cabinet') {
      const cabinet = marketplaces.find(item => normalizeId(item.id) === normalizeId(transfer.scope_id));
      name = cabinet?.account_name;
    }
    return `${kind}: ${name || transfer.scope_id}`;
  };
  return <section className="settings">
            <div className="settings__head">
                <div>
                    <h2>{t.settings}</h2>
                    <p>{t.settings_desc}</p>
                </div>
                {user && <div className="settings__head-row">
                        <span>{t.my_id}</span>
                        <strong>{user.id}</strong>
                        <button type="button" className="icon-button icon-button--copy" onClick={() => copyText(user.id)} title={t.copy}>
                            <IconCopy />
                        </button>
                    </div>}
            </div>

            <div className="settings__tabs">
                <button type="button" className={activeTab === 'cabinets' ? 'active' : ''} onClick={() => setSettingsTab && setSettingsTab('cabinets')}>
                    {t.tab_access}
                </button>
                <button type="button" className={activeTab === 'billing' ? 'active' : ''} onClick={() => setSettingsTab && setSettingsTab('billing')}>
                    Тарифы и оплата
                </button>
                <button type="button" className={activeTab === 'referral' ? 'active' : ''} onClick={() => setSettingsTab && setSettingsTab('referral')}>
                    {t.tab_referral}
                </button>
                <button type="button" className={activeTab === 'account' ? 'active' : ''} onClick={() => setSettingsTab && setSettingsTab('account')}>
                    {t.tab_account}
                </button>
                {SHOW_AI_SETTINGS_TAB && <button type="button" className={activeTab === 'ai' ? 'active' : ''} onClick={() => setSettingsTab && setSettingsTab('ai')}>
                    {t.tab_ai}
                </button>}
                <button type="button" className={activeTab === 'support' ? 'active' : ''} onClick={() => setSettingsTab && setSettingsTab('support')}>
                    {t.tab_support}
                </button>
            </div>

            {activeTab === 'cabinets' && <div className="settings-sections">
                    <ProjectsList workspaces={workspaces} marketplaces={marketplaces} userId={user?.id} request={request} reload={loadWorkspaces} showStatus={showStatus} onOpenProject={projectId => navigate(`/app/projects/${projectId}?project=${projectId}`)} />

                    <DeletedCabinets request={request} fetchBlob={fetchBlob} showStatus={showStatus} onChanged={() => (loadMarketplaces ? loadMarketplaces(companyId) : Promise.resolve())} />

                    {/* РАЗДЕЛ 1: Кабинеты */}
                    <div style={{borderTop: '2px solid var(--surface-border)', paddingTop: '24px', marginTop: '24px'}}>
                        <h3 style={{margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: 'var(--ink)'}}>Кабинеты</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))', gap: '16px'}}>
                        <div className="panel">
                            <div className="panel__head">
                                <h3>{t.connected_accounts}</h3>
                            </div>
                            {marketplaces.length === 0 ? (
                                <div style={{padding: '40px 20px', textAlign: 'center', color: 'var(--ink-soft)'}}>{t.no_cabinets}</div>
                            ) : (
                                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '16px', padding: '16px'}}>
                                    {marketplaces.map(item => {
                        const role = getCabinetRoleLocal(item.id);
                        const canEdit = role === 'owner' || role === 'admin_api';
                        const canTransfer = role === 'owner';
                        const statusLabel = item.status || 'active';
                        const memberCount = item.members_count ?? (item.memberships ? item.memberships.length : 0);
                        const marketplaceLabel = item.marketplace_type === 'ozon' ? 'OZON' : 'WB';
                        return <div key={item.id} style={{border: '1px solid var(--surface-border)', borderRadius: '8px', padding: '16px', background: 'var(--surface)', transition: 'all 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.05)'}} onMouseEnter={(e) => {e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-2px)'}} onMouseLeave={(e) => {e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; e.currentTarget.style.transform = 'translateY(0)'}}>
                                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px'}}>
                                                <div>
                                                    <h4 style={{margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600', color: 'var(--ink)'}}>{item.account_name || item.name || item.id}</h4>
                                                    <span style={{display: 'inline-block', padding: '4px 8px', background: item.marketplace_type === 'ozon' ? 'var(--status-info-bg)' : 'var(--status-warn-bg)', color: item.marketplace_type === 'ozon' ? 'var(--status-info-fg)' : 'var(--status-warn-fg)', borderRadius: '4px', fontSize: '12px', fontWeight: '500'}}>{marketplaceLabel}</span>
                                                </div>
                                                <span style={{display: 'inline-block', padding: '4px 10px', background: statusLabel === 'active' ? 'var(--status-ok-bg)' : 'var(--status-warn-bg)', color: statusLabel === 'active' ? 'var(--status-ok-fg)' : 'var(--status-warn-fg)', borderRadius: '4px', fontSize: '12px', fontWeight: '500'}}>
                                                    {statusLabel === 'active' ? 'Активен' : 'Неактивен'}
                                                </span>
                                            </div>

                                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px', fontSize: '13px'}}>
                                                <div>
                                                    <div style={{color: 'var(--ink-soft)', marginBottom: '4px'}}>Проект</div>
                                                    <div style={{fontWeight: '500', color: 'var(--text-link)'}}>{getCabinetProjects(item.id) || '—'}</div>
                                                </div>
                                                <div>
                                                    <div style={{color: 'var(--ink-soft)', marginBottom: '4px'}}>Члены</div>
                                                    <div style={{fontWeight: '500'}}>{memberCount}</div>
                                                </div>
                                                <div>
                                                    <div style={{color: 'var(--ink-soft)', marginBottom: '4px'}}>Ваша роль</div>
                                                    <div style={{fontWeight: '500'}}>{getAccessRoleLabel(role, role === 'owner', roleOptions)}</div>
                                                </div>
                                                <div>
                                                    <div style={{color: 'var(--ink-soft)', marginBottom: '4px'}}>API</div>
                                                    <div style={{fontWeight: '500', display: 'flex', gap: '4px'}}>
                                                        {item.marketplace_type === 'ozon' ? <>
                                                            <span title="Basic API">✓</span>
                                                            <span title={item.has_performance_api ? "Performance подключен" : "Performance не подключен"} style={{opacity: item.has_performance_api ? 1 : 0.4}}>
                                                                {item.has_performance_api ? '✓P' : '○P'}
                                                            </span>
                                                        </> : <span title="Wildberries API">✓</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{display: 'flex', gap: '8px', paddingTop: '12px', borderTop: '1px solid var(--surface-border)'}}>
                                                {canEdit && <button type="button" className="ghost" onClick={() => openEditAccount(item)} style={{flex: 1, padding: '8px 12px', fontSize: '13px', color: 'var(--text-link)', textAlign: 'center'}}>
                                                    {t.edit_account}
                                                </button>}
                                                {canTransfer && <button type="button" className="ghost" onClick={() => setTransferCabinetId(item.id)} style={{flex: 1, padding: '8px 12px', fontSize: '13px', color: 'var(--text-danger)', textAlign: 'center'}}>
                                                    Передать
                                                </button>}
                                            </div>
                                        </div>;
                    })}
                                </div>
                            )}
                        </div>

                        <div className="panel">
                            <div className="panel__head">
                                <h3>{t.connect_account}</h3>
                            </div>
                            <form autoComplete="off" onSubmit={handleMarketplaceSubmit} className="responsive-form" style={{padding: '16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', alignItems: 'end'}}>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.marketplace}</span>
                                    <select value={marketplaceForm.marketplace_type} onChange={event => setMarketplaceForm(prev => ({
                ...prev,
                marketplace_type: event.target.value
              }))} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>

                                        <option value="ozon">OZON</option>
                                        <option value="wildberries">Wildberries</option>
                                    </select>
                                </label>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.account_name}</span>
                                    <input type="text" autoComplete="off" name="marketplace_account_name" value={marketplaceForm.account_name} onChange={event => setMarketplaceForm(prev => ({
                ...prev,
                account_name: event.target.value
              }))} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px'}} />

                                </label>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.assigned_project}</span>
                                    <select value={marketplaceForm.project_id || ''} onChange={event => setMarketplaceForm(prev => ({
                ...prev,
                project_id: event.target.value
              }))} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>

                                        <option value="">{t.no_project}</option>
                                        {workspaces.map(item => <option key={item.id} value={item.id}>
                                                {item.name || item.id}
                                            </option>)}
                                    </select>
                                </label>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>API Key</span>
                                    <input type="text" autoComplete="new-password" name="anylex_marketplace_api_token" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" autoCorrect="off" autoCapitalize="off" spellCheck={false} value={marketplaceForm.api_key} onChange={event => setMarketplaceForm(prev => ({
                ...prev,
                api_key: event.target.value
              }))} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px'}} />

                                </label>
                                {marketplaceForm.marketplace_type === 'ozon' && <>
                                        <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                            <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>Seller ID</span>
                                            <input type="text" autoComplete="new-password" name="anylex_marketplace_seller_identifier" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" autoCorrect="off" autoCapitalize="off" spellCheck={false} inputMode="numeric" value={marketplaceForm.seller_id} onChange={event => setMarketplaceForm(prev => ({
                  ...prev,
                  seller_id: event.target.value
                }))} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px'}} />

                                        </label>
                                        <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                            <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>Client ID</span>
                                            <input type="text" autoComplete="off" name="anylex_marketplace_client_identifier" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" autoCorrect="off" autoCapitalize="off" spellCheck={false} value={marketplaceForm.client_id} onChange={event => setMarketplaceForm(prev => ({
                  ...prev,
                  client_id: event.target.value
                }))} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px'}} />

                                        </label>
                                        <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                            <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>Client Secret</span>
                                            <input type="text" autoComplete="off" name="anylex_marketplace_client_secret_token" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" autoCorrect="off" autoCapitalize="off" spellCheck={false} value={marketplaceForm.client_secret} onChange={event => setMarketplaceForm(prev => ({
                  ...prev,
                  client_secret: event.target.value
                }))} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px'}} />

                                        </label>
                                    </>}
                                <div style={{gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end'}}>
                                    <button type="submit" disabled={marketplaceBusy} style={{padding: '10px 20px', background: 'var(--action-bg)', color: 'var(--action-fg)', fontWeight: 700, border: 'none', borderRadius: '6px', cursor: marketplaceBusy ? 'not-allowed' : 'pointer', fontSize: '14px', opacity: marketplaceBusy ? 0.6 : 1, height: 'fit-content', whiteSpace: 'nowrap'}}>
                                        {t.connect}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    </div>

                    {/* РАЗДЕЛ 2: Проекты */}
                    <div style={{borderTop: '2px solid var(--surface-border)', paddingTop: '24px', marginTop: '24px'}}>
                        <h3 style={{margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: 'var(--ink)'}}>Проекты</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))', gap: '16px'}}>
                        <div className="panel">
                            <div className="panel__head">
                                <h3>{t.project_staff}</h3>
                            </div>
                            <p className="panel__note">{t.invite_role_hint}</p>
                            <form style={{padding: '16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px', alignItems: 'end'}}>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.project}</span>
                                    <select value={projectAccessWorkspaceId || ''} onChange={event => setProjectAccessWorkspaceId && setProjectAccessWorkspaceId(event.target.value)} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>

                                        {inviteableProjects.length === 0 && <option value="">{t.no_projects}</option>}
                                        {inviteableProjects.map(item => <option key={item.id} value={item.id}>
                                                {item.name || item.id}
                                            </option>)}
                                    </select>
                                </label>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.email}</span>
                                    <input type="email" value={projectAccessIdentity || ''} onChange={event => setProjectAccessIdentity && setProjectAccessIdentity(event.target.value)} placeholder={t.email} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px'}} />
                                </label>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.role}</span>
                                    <select value={projectAccessRole || 'manager'} onChange={event => setProjectAccessRole && setProjectAccessRole(event.target.value)} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>

                                        {(projectRoleOptions.length ? projectRoleOptions : roleOptions.filter(role => role.value !== 'owner')).map(role => <option key={role.value} value={role.value}>{role.label}</option>)}
                                    </select>
                                </label>
                                <button type="submit" disabled={projectAccessBusy} onClick={handleAddProjectMemberSafe} style={{padding: '10px 20px', background: 'var(--action-bg)', color: 'var(--action-fg)', fontWeight: 700, border: 'none', borderRadius: '6px', cursor: projectAccessBusy ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '500', opacity: projectAccessBusy ? 0.6 : 1, height: 'fit-content', whiteSpace: 'nowrap'}}>
                                    {t.invite}
                                </button>
                            </form>
                        </div>

                        <div className="panel">
                            <div className="panel__head">
                                <h3>{t.manage_project_staff}</h3>
                            </div>
                            <div style={{padding: '16px'}}>
                                <div style={{marginBottom: '16px'}}>
                                    <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                        <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.project}</span>
                                        <select value={projectAccessWorkspaceId || ''} onChange={event => setProjectAccessWorkspaceId && setProjectAccessWorkspaceId(event.target.value)} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>
                                            {inviteableProjects.length === 0 && <option value="">{t.no_projects}</option>}
                                            {inviteableProjects.map(item => <option key={item.id} value={item.id}>
                                                    {item.name || item.id}
                                                </option>)}
                                        </select>
                                    </label>
                                </div>

                                {(() => {
                          const projectMembers = getProjectAccessMembers(projectAccessWorkspaceId);
                          return projectMembers.length === 0 ? (
                                        <div style={{padding: '20px', textAlign: 'center', color: 'var(--ink-soft)'}}>{t.no_employees}</div>
                                    ) : (
                                        <div style={{display: 'grid', gap: '8px'}}>
                                            {projectMembers.map(member => {
                                    const memberUser = companyUsers.find(item => normalizeId(item.id) === normalizeId(member.user_id));
                                    const memberRole = member.role;
                                    const isOwner = currentProject && normalizeId(member.user_id) === normalizeId(currentProject.owner_user_id);
                                    const isSelf = normalizeId(member.user_id) === normalizeId(user?.id);
                                    const canEditMember = canManageSelectedProject && !isOwner && !isSelf && getRoleRank(memberRole) <= getRoleRank(currentProjectRole);
                                    const roleLabel = getAccessRoleLabel(memberRole, isOwner, roleOptions);
                                    return <div key={member.id || member.user_id} style={{display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', padding: '12px', background: 'var(--control-bg)', borderRadius: '6px', border: '1px solid var(--surface-border)', gap: '12px'}}>
                                                    <div>
                                                        {renderMemberIdentity(member.user || memberUser, member.user_id)}
                                                        <div style={{fontSize: '12px', color: 'var(--ink-soft)'}}>{roleLabel}</div>
                                                    </div>
                                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end'}}>
                                                        <select value={memberRole} disabled={!canEditMember || manageProjectBusy} onChange={event => handleProjectMemberRoleChange(member, event.target.value)} style={{padding: '6px 10px', border: '1px solid var(--control-border)', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit', cursor: !canEditMember || manageProjectBusy ? 'not-allowed' : 'pointer', opacity: !canEditMember || manageProjectBusy ? 0.6 : 1}}>
                                                            {(projectRoleOptions.length ? projectRoleOptions : roleOptions.filter(role => role.value !== 'owner')).map(role => <option key={role.value} value={role.value}>
                                                                    {role.label}
                                                                </option>)}
                                                        </select>
                                                        <button type="button" disabled={!canEditMember || manageProjectBusy} onClick={() => handleProjectMemberRemove(member)} style={{padding: '6px 10px', background: '#ffebee', color: 'var(--text-danger)', border: '1px solid #ffcdd2', borderRadius: '4px', cursor: !canEditMember || manageProjectBusy ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600', opacity: !canEditMember || manageProjectBusy ? 0.6 : 1, whiteSpace: 'nowrap'}}>
                                                            ✕
                                                        </button>
                                                    </div>
                                                </div>;
                                })}
                                        </div>
                                    );
                        })()}
                            </div>
                        </div>
                    </div>
                    </div>

                    {/* РАЗДЕЛ 3: Кабинеты */}
                    <div style={{borderTop: '2px solid var(--surface-border)', paddingTop: '24px', marginTop: '24px'}}>
                        <h3 style={{margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: 'var(--ink)'}}>Кабинеты</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))', gap: '16px'}}>
                        <div className="panel">
                            <div className="panel__head">
                                <h3>{t.account_staff}</h3>
                            </div>
                            <p className="panel__note">{t.invite_role_hint}</p>
                            <form style={{padding: '16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px', alignItems: 'end'}}>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.account}</span>
                                    <select value={accessAccountId || ''} onChange={event => setAccessAccountId && setAccessAccountId(event.target.value)} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>

                                        {inviteableCabinets.length === 0 && <option value="">{t.no_cabinets}</option>}
                                        {inviteableCabinets.map(item => <option key={item.id} value={item.id}>
                                                {item.account_name || item.name || item.id}
                                            </option>)}
                                    </select>
                                </label>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.email}</span>
                                    <input type="email" value={accessIdentity || ''} onChange={event => setAccessIdentity && setAccessIdentity(event.target.value)} placeholder={t.email} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px'}} />
                                </label>
                                <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.role}</span>
                                    <select value={safeAccessForm.role || 'manager'} onChange={event => updateAccessRole(event.target.value)} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>

                                        {(cabinetRoleOptions.length ? cabinetRoleOptions : roleOptions.filter(role => role.value !== 'owner')).map(role => <option key={role.value} value={role.value}>{role.label}</option>)}
                                    </select>
                                </label>
                                <button type="submit" disabled={accessBusy} onClick={handleAddMemberSafe} style={{padding: '10px 20px', background: 'var(--action-bg)', color: 'var(--action-fg)', fontWeight: 700, border: 'none', borderRadius: '6px', cursor: accessBusy ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '500', opacity: accessBusy ? 0.6 : 1, height: 'fit-content', whiteSpace: 'nowrap'}}>
                                    {t.invite}
                                </button>
                            </form>
                        </div>

                        <div style={{display: 'grid', gap: '16px'}}>
                        <div className="panel">
                            <div className="panel__head">
                                <h3>{t.manage_cabinet_staff}</h3>
                            </div>
                            <div style={{padding: '16px'}}>
                                <div style={{marginBottom: '16px'}}>
                                    <label style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                        <span style={{fontSize: '13px', fontWeight: '500', color: 'var(--ink-soft)'}}>{t.account}</span>
                                        <select value={accessAccountId || ''} onChange={event => setAccessAccountId && setAccessAccountId(event.target.value)} style={{padding: '10px 12px', border: '1px solid var(--control-border)', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit'}}>
                                            {inviteableCabinets.length === 0 && <option value="">{t.no_cabinets}</option>}
                                            {inviteableCabinets.map(item => <option key={item.id} value={item.id}>
                                                    {item.account_name || item.name || item.id}
                                                </option>)}
                                        </select>
                                    </label>
                                </div>

                                {memberships.length === 0 ? (
                                    <div style={{padding: '20px', textAlign: 'center', color: 'var(--ink-soft)'}}>{t.no_employees}</div>
                                ) : (
                                    <div style={{display: 'grid', gap: '8px'}}>
                                        {memberships.map(member => {
                            const memberRole = member.role;
                            const isOwner = memberRole === 'owner';
                            const isSelf = normalizeId(member.user?.id) === normalizeId(user?.id);
                            const canEditMember = canManageSelectedCabinet && !isOwner && !isSelf && getRoleRank(memberRole) <= getRoleRank(currentCabinetRole);
                            const roleLabel = getAccessRoleLabel(memberRole, isOwner, roleOptions);
                            return <div key={member.id} style={{display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', padding: '12px', background: 'var(--control-bg)', borderRadius: '6px', border: '1px solid var(--surface-border)', gap: '12px'}}>
                                                <div>
                                                    {renderMemberIdentity(member.user, member.user?.id)}
                                                    <div style={{fontSize: '12px', color: 'var(--ink-soft)'}}>{roleLabel}</div>
                                                </div>
                                                <div style={{display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end'}}>
                                                    <select value={memberRole} disabled={!canEditMember || manageCabinetBusy} onChange={event => handleCabinetMemberRoleChange(member, event.target.value)} style={{padding: '6px 10px', border: '1px solid var(--control-border)', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit', cursor: !canEditMember || manageCabinetBusy ? 'not-allowed' : 'pointer', opacity: !canEditMember || manageCabinetBusy ? 0.6 : 1}}>
                                                        {(cabinetRoleOptions.length ? cabinetRoleOptions : roleOptions.filter(role => role.value !== 'owner')).map(role => <option key={role.value} value={role.value}>
                                                                {role.label}
                                                            </option>)}
                                                    </select>
                                                    <button type="button" disabled={!canEditMember || manageCabinetBusy} onClick={() => handleCabinetMemberRemove(member)} style={{padding: '6px 10px', background: '#ffebee', color: 'var(--text-danger)', border: '1px solid #ffcdd2', borderRadius: '4px', cursor: !canEditMember || manageCabinetBusy ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600', opacity: !canEditMember || manageCabinetBusy ? 0.6 : 1, whiteSpace: 'nowrap'}}>
                                                        ✕
                                                    </button>
                                                </div>
                                            </div>;
                        })}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="panel">
                            <div className="panel__head">
                                <h3>Отправленные приглашения</h3>
                            </div>
                            <div style={{padding: '16px'}}>
                                {sentCabinetInvites.length === 0 ? (
                                    <div style={{padding: '20px', textAlign: 'center', color: 'var(--ink-soft)'}}>{t.invite_empty}</div>
                                ) : (
                                    <div style={{display: 'grid', gap: '8px'}}>
                                        {sentCabinetInvites.map(invite => <div key={invite.id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', background: 'var(--control-bg)', borderRadius: '6px', border: '1px solid var(--surface-border)', gap: '12px', flexWrap: 'wrap'}}>
                                                <div>
                                                    <div style={{fontWeight: '500', fontSize: '14px'}}>{invite.email}</div>
                                                    <div style={{fontSize: '12px', color: 'var(--ink-soft)'}}>{getAccessRoleLabel(invite.role, invite.role === 'owner', roleOptions)}</div>
                                                </div>
                                                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                    {getInviteStatusBadge(invite.status)}
                                                    {invite.status === 'pending' && <button type="button" className="ghost" onClick={() => handleCancelSentInvite && handleCancelSentInvite(invite.id)} style={{padding: '6px 12px', cursor: 'pointer', fontSize: '13px', color: 'var(--text-danger)', whiteSpace: 'nowrap'}}>{t.decline}</button>}
                                                </div>
                                            </div>)}
                                    </div>
                                )}
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                    {/* РАЗДЕЛ 4: Приглашения */}
                    <div style={{borderTop: '2px solid var(--surface-border)', paddingTop: '24px', marginTop: '24px'}}>
                        <h3 style={{margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: 'var(--ink)'}}>Приглашения</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))', gap: '16px'}}>
                    {ownershipTransfers.length > 0 && <div className="panel">
                        <div className="panel__head">
                            <h3>{t.transfer_requests}</h3>
                        </div>
                        <div style={{padding: '16px', display: 'grid', gap: '12px'}}>
                            {ownershipTransfers.map(transfer => {
              const senderName = transfer.from_user_name || '';
              const senderEmail = transfer.from_user_email || '';
              const sender = senderName && senderEmail ? `${senderName} (${senderEmail})` : senderName || senderEmail;
              return <div key={transfer.id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', background: 'var(--control-bg)', borderRadius: '6px', border: '1px solid var(--surface-border)', gap: '12px', flexWrap: 'wrap'}}>
                                    <div style={{minWidth: '200px'}}>
                                        <div style={{fontWeight: '500'}}>{getTransferScopeLabel(transfer)}</div>
                                        {sender && <div style={{fontSize: '12px', color: 'var(--ink-soft)'}}>Передаёт: {sender}</div>}
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        <button type="button" disabled={ownershipBusy} style={{padding: '6px 12px', background: 'var(--action-bg)', color: 'var(--action-fg)', fontWeight: 700, border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap'}} onClick={() => handleTransferAction(transfer.id, 'accept')}>{t.accept}</button>
                                        <button type="button" disabled={ownershipBusy} className="ghost" style={{padding: '6px 12px', cursor: 'pointer', fontSize: '13px', color: 'var(--text-danger)', whiteSpace: 'nowrap'}} onClick={() => handleTransferAction(transfer.id, 'reject')}>{t.decline}</button>
                                    </div>
                                </div>;
            })}
                        </div>
                    </div>}
                    <div className="panel">
                        <div className="panel__head">
                            <h3>Приглашения в кабинеты</h3>
                        </div>
                        {cabinetInvites.length === 0 ? (
                            <div style={{padding: '20px', textAlign: 'center', color: 'var(--ink-soft)'}}>{t.invite_empty}</div>
                        ) : (
                            <div style={{padding: '16px', display: 'grid', gap: '12px'}}>
                                {cabinetInvites.map(invite => <div key={invite.id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', background: 'var(--control-bg)', borderRadius: '6px', border: '1px solid var(--surface-border)', gap: '12px', flexWrap: 'wrap'}}>
                                    <span style={{fontWeight: '500', minWidth: '200px'}}>{`Кабинет: ${invite.marketplace_account_name || invite.marketplace_account_id}`}</span>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        {getInviteStatusBadge(invite.status)}
                                        <button type="button" style={{padding: '6px 12px', background: 'var(--action-bg)', color: 'var(--action-fg)', fontWeight: 700, border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap'}} onClick={() => handleCabinetInvite(invite.id, 'accept')}>{t.accept}</button>
                                        <button type="button" className="ghost" style={{padding: '6px 12px', cursor: 'pointer', fontSize: '13px', color: 'var(--text-danger)', whiteSpace: 'nowrap'}} onClick={() => handleCabinetInvite(invite.id, 'reject')}>{t.decline}</button>
                                    </div>
                                </div>)}
                            </div>
                        )}
                    </div>
                    <div className="panel">
                        <div className="panel__head">
                            <h3>{t.project_invites}</h3>
                        </div>
                        {projectInvites.length === 0 ? (
                            <div style={{padding: '20px', textAlign: 'center', color: 'var(--ink-soft)'}}>{t.invite_empty}</div>
                        ) : (
                            <div style={{padding: '16px', display: 'grid', gap: '12px'}}>
                                {projectInvites.map(invite => <div key={invite.id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', background: 'var(--control-bg)', borderRadius: '6px', border: '1px solid var(--surface-border)', gap: '12px', flexWrap: 'wrap'}}>
                                    <span style={{fontWeight: '500', minWidth: '200px'}}>{`Проект: ${invite.workspace_name || invite.workspace_id}`}</span>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        {getInviteStatusBadge(invite.status)}
                                        <button type="button" style={{padding: '6px 12px', background: 'var(--action-bg)', color: 'var(--action-fg)', fontWeight: 700, border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap'}} onClick={() => handleProjectInvite(invite.id, 'accept')}>{t.accept}</button>
                                        <button type="button" className="ghost" style={{padding: '6px 12px', cursor: 'pointer', fontSize: '13px', color: 'var(--text-danger)', whiteSpace: 'nowrap'}} onClick={() => handleProjectInvite(invite.id, 'reject')}>{t.decline}</button>
                                    </div>
                                </div>)}
                            </div>
                        )}
                    </div>
                    </div>
                    </div>
                </div>}

            {activeTab === 'billing' && <div className="settings-sections">

                    {/* ── Тарифы и инструменты ────────────────────────────── */}
                    <div className="panel">
                        <div className="panel__head">
                            <h3>Тарифы и инструменты</h3>
                            <button type="button" className="ghost" onClick={loadBilling} disabled={shopPlansBusy}>Обновить</button>
                        </div>
                        <div style={{ padding: '16px' }}>
                            <PricingCatalogPanel
                                shopPlans={shopPlans}
                                onChangePlan={handleShopPlanChange}
                                planChanging={shopPlanChanging}
                                refreshKey={activeTab}
                            />
                        </div>
                    </div>

                    <div className="panel">
                        <h3>{t.promo_title}</h3>
                        <form className="billing-promo" onSubmit={handlePromoApply}>
                            <input type="text" placeholder={t.promo_placeholder} value={billingPromoCode} onChange={event => setBillingPromoCode(event.target.value)} />

                            <button type="submit" disabled={billingPromoBusy}>
                                {billingPromoBusy ? '...' : t.promo_apply}
                            </button>
                            {billingSummary?.promo_code && <div className="billing-promo__active">
                                    <span>{t.promo_active}:</span>
                                    <strong>
                                        {billingSummary.promo_code}
                                        {billingSummary.promo_discount_percent ? ` (-${billingSummary.promo_discount_percent}%)` : ''}
                                    </strong>
                                </div>}
                        </form>
                    </div>

                    <div className="settings-grid settings-grid--two">
                        <div className="panel">
                            <div className="panel__head">
                                <h3>{t.billing_topup}</h3>
                                <span className="muted">
                                    {t.billing_balance}: <strong>{formatMoney(billingSummary?.balance, billingSummary?.currency || 'RUB')}</strong>
                                </span>
                            </div>
                            <form className="billing-form" onSubmit={handleBillingTopup}>
                                <label>
                                    {t.billing_amount}
                                    <input type="number" min="0" step="0.01" value={billingTopup.amount} onChange={event => setBillingTopup(prev => ({
                ...prev,
                amount: event.target.value
              }))} />

                                </label>
                                <label>
                                    {t.billing_description}
                                    <input type="text" value={billingTopup.description} onChange={event => setBillingTopup(prev => ({
                ...prev,
                description: event.target.value
              }))} placeholder="Оплата тарифа" />

                                </label>
                                <div>
                                    <button type="submit" disabled={billingTopupBusy}>
                                        {billingTopupBusy ? 'Создание...' : t.billing_pay_card}
                                    </button>
                                </div>
                            </form>

                            <div className="billing-divider" />

                            <h4>{t.billing_pay_invoice}</h4>
                            <form className="billing-form" onSubmit={handleInvoiceCreate}>
                                <label>
                                    {t.billing_invoice_amount}
                                    <input type="number" min="0" step="0.01" value={billingInvoice.amount} onChange={event => setBillingInvoice(prev => ({
                ...prev,
                amount: event.target.value
              }))} />

                                </label>
                                <label>
                                    {t.billing_description}
                                    <input type="text" value={billingInvoice.description} onChange={event => setBillingInvoice(prev => ({
                ...prev,
                description: event.target.value
              }))} placeholder="Оплата тарифа по счету" />

                                </label>
                                <div>
                                    <button type="submit" disabled={billingInvoiceBusy}>
                                        {billingInvoiceBusy ? 'Создание...' : t.billing_invoice_create}
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div className="panel">
                            <h3>{t.billing_payer_title}</h3>
                            <p className="muted">{t.billing_payer_hint}</p>
                            <form className="billing-form" onSubmit={handlePayerSave}>
                                <label>
                                    {t.company_name}
                                    <DadataSuggest
                                        value={billingPayerForm.payer_name}
                                        endpoint="/api/v1/billing/dadata/party"
                                        placeholder="Название или ИНН"
                                        onChange={v => setBillingPayerForm(prev => ({ ...prev, payer_name: v }))}
                                        onSelect={s => { const d = s.data || {}; setBillingPayerForm(prev => ({ ...prev, payer_name: s.value, inn: d.inn || prev.inn, ogrn: d.ogrn || d.ogrnip || prev.ogrn, address: d.address?.unrestricted_value || prev.address })); }}
                                        renderItem={s => (<><span className="dd-item-name">{s.value}</span><span className="dd-item-meta">ИНН {s.data?.inn}{s.data?.address?.value ? ` · ${s.data.address.value}` : ''}</span></>)}
                                    />
                                </label>
                                <label>
                                    {t.inn}
                                    <DadataSuggest
                                        value={billingPayerForm.inn}
                                        endpoint="/api/v1/billing/dadata/party"
                                        findEndpoint="/api/v1/billing/dadata/party/find"
                                        minLength={10}
                                        placeholder="ИНН (10 или 12 цифр)"
                                        onChange={v => setBillingPayerForm(prev => ({ ...prev, inn: v }))}
                                        onSelect={s => { const d = s.data || {}; setBillingPayerForm(prev => ({ ...prev, payer_name: s.value, inn: d.inn || prev.inn, ogrn: d.ogrn || d.ogrnip || prev.ogrn, address: d.address?.unrestricted_value || prev.address })); }}
                                        renderItem={s => (<><span className="dd-item-name">{s.value}</span><span className="dd-item-meta">ИНН {s.data?.inn}</span></>)}
                                    />
                                </label>
                                <label>
                                    {'\u041e\u0413\u0420\u041d / \u041e\u0413\u0420\u041d\u0418\u041f'}
                                    <input type="text" value={billingPayerForm.ogrn} onChange={event => setBillingPayerForm(prev => ({
                ...prev,
                ogrn: event.target.value
              }))} />

                                </label>
                                <label>
                                    {t.legal_address}
                                    <input type="text" value={billingPayerForm.address} onChange={event => setBillingPayerForm(prev => ({
                ...prev,
                address: event.target.value
              }))} />

                                </label>
                                <label>
                                    {'\u0411\u0418\u041a'}
                                    <DadataSuggest
                                        value={billingPayerForm.bik}
                                        endpoint="/api/v1/billing/dadata/bank"
                                        placeholder={'\u0411\u0418\u041a \u0438\u043b\u0438 \u043d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u0431\u0430\u043d\u043a\u0430'}
                                        onChange={v => setBillingPayerForm(prev => ({ ...prev, bik: v }))}
                                        onSelect={s => { const d = s.data || {}; setBillingPayerForm(prev => ({ ...prev, bik: d.bic || prev.bik, corr_account: d.correspondent_account || prev.corr_account })); }}
                                        renderItem={s => (<><span className="dd-item-name">{s.value}</span><span className="dd-item-meta">{'\u0411\u0418\u041a'} {s.data?.bic}{s.data?.correspondent_account ? ` \u00b7 \u043a/\u0441 ${s.data.correspondent_account}` : ''}</span></>)}
                                    />
                                </label>
                                <label>
                                    {'\u041a\u043e\u0440\u0441\u0447\u0435\u0442'}
                                    <input type="text" value={billingPayerForm.corr_account} onChange={event => setBillingPayerForm(prev => ({
                ...prev,
                corr_account: event.target.value
              }))} />

                                </label>
                                <label>
                                    {'\u0420\u0430\u0441\u0447\u0435\u0442\u043d\u044b\u0439 \u0441\u0447\u0435\u0442'}
                                    <input type="text" value={billingPayerForm.settlement_account} onChange={event => setBillingPayerForm(prev => ({
                ...prev,
                settlement_account: event.target.value
              }))} />

                                </label>
                                <div>
                                    <button type="submit" disabled={billingPayerBusy}>
                                        {billingPayerBusy ? 'Сохранение...' : t.billing_payer_save}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="panel">
                        <div className="panel__head">
                            <h3>{t.billing_invoices}</h3>
                            <button type="button" className="ghost" onClick={loadBilling} disabled={billingBusy}>
                                Обновить
                            </button>
                        </div>
                        <div className="table-scroll">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Номер</th>
                                        <th>Сумма</th>
                                        <th>Статус</th>
                                        <th>Дата</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {billingInvoices.length === 0 && <tr>
                                            <td colSpan={5}>{t.billing_invoices_empty}</td>
                                        </tr>}
                                    {billingInvoices.map(invoice => <tr key={invoice.id}>
                                            <td>{invoice.invoice_number}</td>
                                            <td>{formatMoney(invoice.amount, invoice.currency)}</td>
                                            <td>{formatTransactionStatus(invoice.status)}</td>
                                            <td>{formatDateTime(invoice.created_at)}</td>
                                            <td>
                                                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                                                    <button type="button" className="ghost" onClick={() => handleInvoiceDownload(invoice.id, invoice.invoice_number)}>
                                                        {t.billing_invoice_download}
                                                    </button>
                                                    {(invoiceDocs[invoice.id] || []).map(doc => {
                                                        const handleDocDownload = async (docId, fileName) => {
                                                            try {
                                                                saveBlob(await fetchBlob(`/api/v1/billing/closing-docs/${docId}/download`), fileName);
                                                            } catch (e) {
                                                                logger.error('Doc download failed:', e);
                                                                showStatus('error', 'Не удалось скачать документ: ' + (e?.message || ''));
                                                            }
                                                        };
                                                        return (
                                                            <button key={doc.id}
                                                                type="button"
                                                                className="ghost"
                                                                onClick={() => handleDocDownload(doc.id, doc.file_name)}
                                                                style={{ fontSize: 12, padding: '4px 8px', border: '1px solid var(--control-border)', borderRadius: 4, background: 'none', cursor: 'pointer', color: '#2980b9', whiteSpace: 'nowrap' }}>
                                                                {doc.doc_type}: {doc.file_name}
                                                            </button>
                                                        );
                                                    })}
                                                    <button type="button" className="ghost" style={{ color: '#e74c3c' }}
                                                        onClick={async () => {
                                                            if (!window.confirm('Удалить счёт?')) return;
                                                            try {
                                                                await request(`/api/v1/billing/invoices/${invoice.id}`, { method: 'DELETE' });
                                                                setBillingInvoices(prev => prev.filter(i => i.id !== invoice.id));
                                                            } catch (e) {
                                                                logger.error('Invoice delete failed:', e);
                                                                showStatus('error', 'Не удалось удалить счёт: ' + (e?.message || ''));
                                                            }
                                                        }}>
                                                        Удалить
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="panel">
                        <div className="panel__head">
                            <h3>{t.billing_transactions}</h3>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <button type="button" className="ghost" onClick={downloadTransactions} title="Вся история операций файлом CSV (открывается в Excel)">
                                    Скачать всю историю
                                </button>
                                <button type="button" className="ghost" onClick={loadBilling} disabled={billingBusy}>
                                    Обновить
                                </button>
                            </div>
                        </div>
                        <div className="table-scroll">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Тип</th>
                                        <th>Сумма</th>
                                        <th>Статус</th>
                                        <th>Дата</th>
                                        <th>Комментарий</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {billingBusy && <tr>
                                            <td colSpan={5}>{t.billing_loading}</td>
                                        </tr>}
                                    {!billingBusy && billingTransactions.length === 0 && <tr>
                                            <td colSpan={5}>{t.billing_empty}</td>
                                        </tr>}
                                    {!billingBusy && billingTransactions.map(tx => <tr key={tx.id}>
                                            <td>{formatTransactionType(tx.transaction_type)}</td>
                                            <td>{formatMoney(tx.amount, tx.currency)}</td>
                                            <td>{formatTransactionStatus(tx.status)}</td>
                                            <td>{formatDateTime(tx.created_at)}</td>
                                            <td>{formatTransactionComment(tx)}</td>
                                        </tr>)}
                                </tbody>
                            </table>
                        </div>
                        {txTotal > TX_PAGE && (
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8 }}>
                                <button type="button" className="ghost" disabled={txBusy || txOffset === 0} onClick={() => loadTransactionsPage(Math.max(txOffset - TX_PAGE, 0))}>Назад</button>
                                <span>{txOffset + 1}–{Math.min(txOffset + TX_PAGE, txTotal)} из {txTotal}</span>
                                <button type="button" className="ghost" disabled={txBusy || txOffset + TX_PAGE >= txTotal} onClick={() => loadTransactionsPage(txOffset + TX_PAGE)}>Дальше</button>
                            </div>
                        )}
                    </div>

                </div>}
            {activeTab === 'referral' && <div className="settings-sections">
                    {/* Основная информация */}
                    <div className="settings-grid settings-grid--two">
                        <div className="panel">
                            <h3>{t.referral_code_title}</h3>
                            <div className="referral-code">
                                <span className="code-text">{referralStats?.code || '—'}</span>
                                <button type="button" className="icon-button icon-button--copy" onClick={() => copyText(referralStats?.code || '')} title={t.referral_copy}>
                                    <IconCopy />
                                </button>
                            </div>
                            <p className="muted">Приглашённый вводит этот код в поле «Промокод» при регистрации</p>
                        </div>

                        <div className="panel">
                            <h3>{t.referral_link_title}</h3>
                            <div className="referral-code">
                                <span className="code-text">{`https://seller.anylex.ru/?ref=${referralStats?.code || '...'}`}</span>
                                <button type="button" className="icon-button icon-button--copy" onClick={() => copyText(`https://seller.anylex.ru/?ref=${referralStats?.code || ''}`)} title={t.referral_copy}>
                                    <IconCopy />
                                </button>
                            </div>
                            <p className="muted">Используйте эту ссылку для шаринга</p>
                        </div>
                    </div>

                    {/* Статистика */}
                    <div className="panel">
                        <div className="panel__head">
                            <h3>{t.referral_stats_title}</h3>
                            <button type="button" className="ghost" onClick={loadReferrals} disabled={referralBusy}>
                                Обновить
                            </button>
                        </div>
                        <div className="table-scroll">
                            <table className="data-table">
                                <tbody>
                                    <tr>
                                        <td>{t.referral_stat_links}</td>
                                        <td><strong>{referralStats?.total_invites ?? 0}</strong></td>
                                    </tr>
                                    <tr>
                                        <td>{t.referral_stat_applied}</td>
                                        <td><strong>{referralStats?.active_invites ?? 0}</strong></td>
                                    </tr>
                                    <tr>
                                        <td>{t.referral_stat_income}</td>
                                        <td>
                                            <strong>{Number(referralStats?.balance ?? 0).toFixed(2)} {t.referral_stat_income_rub}</strong>
                                            <button type="button" className="button button--sm" style={{marginLeft: '12px'}} onClick={() => document.getElementById('referral-withdrawal')?.scrollIntoView({ behavior: 'smooth' })}>
                                                {t.referral_withdrawal}
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{t.referral_stat_balance}</td>
                                        <td><strong>{Number(referralStats?.total_earned ?? 0).toFixed(2)}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Текущие параметры рефералки */}
                    {referralParams && <div className="panel">
                        <h3>Ваши условия</h3>
                        <div className="referral-bonuses">
                            <p className="muted">С каждого пополнения приглашённого вами:</p>
                            <ul>
                                {Number(referralParams.l1_rub_percent) > 0 && (
                                    <li>💰 <strong>{Number(referralParams.l1_rub_percent)}%</strong> — в реферальный кошелёк, можно вывести деньгами
                                        {referralParams.l1_rub_monthly_cap != null && <> (не больше {Number(referralParams.l1_rub_monthly_cap)} ₽ в месяц с одного приглашённого)</>}
                                    </li>
                                )}
                                {Number(referralParams.l1_balance_percent) > 0 && (
                                    <li>💳 <strong>{Number(referralParams.l1_balance_percent)}%</strong> — на ваш основной баланс</li>
                                )}
                                {Number(referralParams.l2_balance_percent) > 0 && (
                                    <li>👥 <strong>{Number(referralParams.l2_balance_percent)}%</strong> на баланс — с пополнений тех, кого пригласили ваши приглашённые</li>
                                )}
                            </ul>
                            {(Number(referralParams.welcome_bonus_amount) > 0 || Number(referralParams.first_purchase_bonus_percent) > 0) && <>
                                <p className="muted">Приглашённый получает:</p>
                                <ul>
                                    {Number(referralParams.welcome_bonus_amount) > 0 && (
                                        <li>🎁 <strong>{Number(referralParams.welcome_bonus_amount)} ₽</strong> на баланс сразу после регистрации</li>
                                    )}
                                    {Number(referralParams.first_purchase_bonus_percent) > 0 && (
                                        <li>📊 <strong>+{Number(referralParams.first_purchase_bonus_percent)}%</strong> к первому пополнению</li>
                                    )}
                                </ul>
                            </>}
                            {referralParams.applied_promo_code && <p className="muted" style={{marginTop: '12px'}}>Персональные условия по промокоду <strong>{referralParams.applied_promo_code}</strong></p>}
                        </div>
                    </div>}

                    {/* Применение персонального агентского промокода */}
                    {!referralParams?.applied_promo_code && <div className="panel">
                        <h3>{t.referral_apply_promo}</h3>
                        <p className="muted">{t.referral_apply_promo_hint}</p>
                        <form className="referral-form" onSubmit={handleApplyAgentPromo} style={{marginTop: '12px'}}>
                            <input
                                type="text"
                                placeholder="Персональный промокод"
                                value={referralAgentCode}
                                onChange={event => setReferralAgentCode(event.target.value)}
                            />
                            <button type="submit" disabled={referralAgentCodeBusy}>
                                {referralAgentCodeBusy ? 'Применение...' : t.referral_apply_promo}
                            </button>
                        </form>
                    </div>}

                    {/* Заявка на вывод денег */}
                    <div className="panel" id="referral-withdrawal">
                        <h3>Вывод денег</h3>
                        <p className="muted">Заполните реквизиты для вывода реферальных вознаграждений.</p>
                        <form className="referral-form" onSubmit={handleWithdrawalSubmit} style={{marginTop: '12px'}}>
                            <div style={{marginBottom: '12px'}}>
                                <label style={{fontSize: '12px', fontWeight: '500', marginBottom: '6px', display: 'block'}}>Сумма ₽</label>
                                <input
                                    type="number"
                                    name="amount"
                                    placeholder="1000"
                                    step="0.01"
                                    min="0"
                                    value={withdrawalForm.amount}
                                    onChange={handleWithdrawalChange}
                                    required
                                />
                            </div>
                            <div style={{marginBottom: '12px'}}>
                                <label style={{fontSize: '12px', fontWeight: '500', marginBottom: '6px', display: 'block'}}>ИНН компании</label>
                                <DadataSuggest
                                    value={withdrawalForm.inn}
                                    onChange={v => setWithdrawalForm(f => ({...f, inn: v}))}
                                    endpoint="/api/v1/billing/dadata/party"
                                    findEndpoint="/api/v1/billing/dadata/party/find"
                                    minLength={3}
                                    placeholder="7701000146 или название компании"
                                    renderItem={item => item.value ? `${item.value} (${item.data?.inn})` : item.value}
                                    onSelect={item => {
                                        if (item.data?.name?.full_with_opf) {
                                            setWithdrawalForm(f => ({
                                                ...f,
                                                recipient_name: item.data.name.full_with_opf,
                                                inn: item.data.inn || f.inn
                                            }));
                                        }
                                    }}
                                />
                            </div>
                            <div style={{marginBottom: '12px'}}>
                                <label style={{fontSize: '12px', fontWeight: '500', marginBottom: '6px', display: 'block'}}>Наименование или ФИО получателя</label>
                                <input
                                    type="text"
                                    name="recipient_name"
                                    placeholder="Иван Иванов"
                                    value={withdrawalForm.recipient_name}
                                    onChange={handleWithdrawalChange}
                                    required
                                />
                            </div>
                            <div style={{marginBottom: '12px'}}>
                                <label style={{fontSize: '12px', fontWeight: '500', marginBottom: '6px', display: 'block'}}>БИК банка</label>
                                <DadataSuggest
                                    value={withdrawalForm.bik}
                                    onChange={v => setWithdrawalForm(f => ({...f, bik: v}))}
                                    endpoint="/api/v1/billing/dadata/bank"
                                    minLength={3}
                                    placeholder="044525225 или название банка"
                                    renderItem={item => item.value ? `${item.value} (${item.data?.bic})` : item.value}
                                    onSelect={item => {
                                        if (item.data?.bic) {
                                            setWithdrawalForm(f => ({
                                                ...f,
                                                bik: item.data.bic
                                            }));
                                        }
                                    }}
                                />
                            </div>
                            <div style={{marginBottom: '12px'}}>
                                <label style={{fontSize: '12px', fontWeight: '500', marginBottom: '6px', display: 'block'}}>Номер счёта</label>
                                <input
                                    type="text"
                                    name="account_number"
                                    placeholder="40817810099910001234"
                                    value={withdrawalForm.account_number}
                                    onChange={handleWithdrawalChange}
                                    required
                                />
                            </div>
                            {withdrawalError && <div className="promo-error" style={{marginBottom: '12px'}}>{withdrawalError}</div>}
                            {withdrawalSuccess && <div className="promo-success" style={{marginBottom: '12px'}}>{withdrawalSuccess}</div>}
                            <button type="submit" disabled={withdrawalBusy}>
                                {withdrawalBusy ? 'Создание...' : 'Создать заявку на вывод'}
                            </button>
                        </form>

                        {withdrawalRequests.length > 0 && (
                            <div style={{marginTop: '24px'}}>
                                <h4>История заявок на вывод</h4>
                                <table className="promo-table" style={{marginTop: '12px'}}>
                                    <thead>
                                        <tr>
                                            <th>Сумма</th>
                                            <th>Статус</th>
                                            <th>Дата</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {withdrawalRequests.map(w => (
                                            <tr key={w.id}>
                                                <td>{w.amount} ₽</td>
                                                <td><span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    backgroundColor: w.status === 'paid' ? 'var(--status-ok-bg)' : w.status === 'pending' ? 'var(--status-warn-bg)' : 'var(--status-bad-bg)',
                                                    color: w.status === 'paid' ? 'var(--status-ok-fg)' : w.status === 'pending' ? 'var(--status-warn-fg)' : 'var(--status-bad-fg)'
                                                }}>{w.status}</span></td>
                                                <td>{fmtDate(w.created_at)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>}

            {activeTab === 'support' && <SupportPanel />}

            {activeTab === 'account' && <div className="settings-sections">
                    <AccountSection user={user} summary={profileSummary} summaryBusy={profileSummaryBusy} stats={profileStats} onSave={handleProfileSave} onAvatarUpload={handleAvatarUpload} onCertificatesUpload={handleCertificatesUpload} onTelegramLink={handleTelegramLink} onCopy={copyText} busy={profileBusy} avatarBusy={avatarBusy} certificatesBusy={certificatesBusy} telegramBusy={telegramBusy} />
                    <AccountDataPanel />
                    <div className="panel">
                      <div className="panel__head">
                        <h3>Вводный тур</h3>
                      </div>
                      <div style={{ padding: '16px 20px' }}>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: 'var(--ink-soft)' }}>
                          Короткое знакомство с интерфейсом: проекты, кабинеты, тарифы и лимиты.
                        </p>
                        <button type="button" className="btn-primary" disabled={onboardingBusy} onClick={handleRestartOnboarding}>
                          Пройти заново
                        </button>
                      </div>
                    </div>
                </div>}

            {SHOW_AI_SETTINGS_TAB && activeTab === 'ai' && <div className="settings-sections">
                    <div className="panel empty">AI-настройки пересобираются, скоро вернутся.</div>
                </div>}

            <TransferCabinetModal cabinet={transferCabinet} request={request} currentUserId={user?.id} busy={ownershipBusy} onClose={() => setTransferCabinetId('')} onSubmit={recipientId => createTransfer('cabinet', transferCabinetId, recipientId, () => setTransferCabinetId(''))} />
            <EditAccountModal editAccount={editAccount} editForm={editForm} setEditForm={setEditForm} editBusy={editBusy} onClose={closeEditAccount} onSubmit={handleEditSubmit} projectOptions={ownedProjects} canEditName={canEditName} canEditProject={canEditProject} onDelete={handleDeleteAccount} currentUserId={user?.id} />

        </section>;
}
export default SettingsPanel;
